import React, {ReactNode} from "react";
import Downloader from "../document/Downloader";
import {Slider} from "primereact/slider";
import {InputNumber} from "primereact/inputnumber";
import PortalDocument, {PortalDocumentInterface} from "../document/PortalDocument";
import ZoomMode from "../viewer/settings/ZoomMode";
import MouseMode from "../viewer/settings/MouseMode";
import PageViewMode from "../viewer/settings/PageViewMode";
import ContentMode from "../ContentMode";
import MimeTypes from "../document/mimetype/MimeTypes";
import DocumentSettings from "../document/DocumentSettings";
import MimeTypeFilter from "../document/mimetype/MimeTypeFilter";
import {DeleteDialogDefinition} from "../dialog/components/document/DeleteDialog";
import Parameter from "../dialog/parameter/Parameter";
import {RenameDialogDefinition} from "../dialog/components/document/RenameDialog";
import {PrintDialogDefinition} from "../dialog/components/document/PrintDialog";
import PortalDocumentManager, {PortalDocumentManagerGlobals} from "../document/PortalDocumentManager";
import {RotateDialogDefinition} from "../dialog/components/page/RotateDialog";
import PortalDialogType from "../dialog/PortalDialogType";
import {DeletePageDialogDefinition} from "../dialog/components/page/DeletePageDialog";
import {SplitDialogDefinition} from "../dialog/components/page/SplitDialog";
import {WatermarkDialogDefinition} from "../dialog/components/page/WatermarkDialog";
import {GlobalAttachmentDialogDefinition} from "../dialog/components/attachment/GlobalAttachmentDialog";
import {ContentExtractionDialogDefinition} from "../dialog/components/export/ContentExtractionDialog";
import {ImageExtractionDialogDefinition} from "../dialog/components/export/ImageExtractionDialog";
import {InfoExtractionDialogDefinition} from "../dialog/components/export/InfoExtractionDialog";
import {PageExtractionDialogDefinition} from "../dialog/components/export/PageExtractionDialog";
import {BackgroundDialogDefinition} from "../dialog/components/page/BackgroundDialog";
import {HeaderFooterDialogDefinition} from "../dialog/components/page/HeaderFooterDialog";
import {BoxesDialogDefinition} from "../dialog/components/page/BoxesDialog";
import {TransitionDialogDefinition} from "../dialog/components/page/TransitionDialog";
import {PageAddDialogDefinition} from "../dialog/components/page/PageAddDialog";
import {PdfaDialogDefinition} from "../dialog/components/convert/PdfaDialog";
import {OcrDialogDefinition} from "../dialog/components/convert/OcrDialog";
import {SignatureDialogDefinition} from "../dialog/components/signature/SignatureDialog";
import {FormsFlattenDialogDefinition} from "../dialog/components/forms/FormsFlattenDialog";
import {FormsExtractionDialogDefinition} from "../dialog/components/forms/FormsExtractionDialog";
import {FormsImportDialogDefinition} from "../dialog/components/forms/FormsImportDialog";
import {SanitizeDialogDefinition} from "../dialog/components/document/SanitizeDialog";
import {RedactPageDialogDefinition} from "../dialog/components/redact/RedactPageDialog";
import DialogDefault from "../dialog/parameter/PortalDialogDefault";
import {RedactDialogDefinition} from "../dialog/components/redact/RedactDialog";
import MouseFunction from "../viewer/settings/MouseFunction";
import {AreaLayerGlobals} from "../viewer/pdf/AreaLayerInterface";
import {BarcodeCreateAreaDialogDefinition} from "../dialog/components/barcode/BarcodeCreateAreaDialog";
import {
	AddToolboxAnnotation,
	AppearanceAdd,
	Attachment,
	AuthProvider,
	Information,
	Limits,
	LineAnnotation,
	LineAnnotationInterface,
	Metrics,
	Point,
	PortalFunctions,
	PositionRubberStampAnnotation,
	PositionRubberStampAnnotationInterface,
	PositionSimpleShapeAnnotation,
	PositionSimpleShapeAnnotationInterface,
	QrSwissPaymentFormat,
	Rectangle,
	RectangleInterface,
	RubberStampIcon,
	Signature,
	SignaturePosition,
	ToolboxAnnotationAnnotation,
	ToolboxAttachmentAttachment,
	ToolboxFormsForms,
	ToolboxRotateRotate,
	UserCertificates,
	UserCredentials,
	UserInterfaceResources,
	WatermarkPosition,
	WatermarkPositionMode
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {BarcodeDetectDialogDefinition} from "../dialog/components/barcode/BarcodeDetectDialog";
import {RedactAreaFunctionDefinition} from "../document/components/pdf/redact/RedactAreaFunction";
import {AnnotationNoteFunctionDefinition} from "../document/components/pdf/annotation/AnnotationNoteFunction";
import {AnnotationMarkFunctionDefinition} from "../document/components/pdf/annotation/AnnotationMarkFunction";
import {AnnotationUnderlineFunctionDefinition} from "../document/components/pdf/annotation/AnnotationUnderlineFunction";
import {AnnotationStrikeFunctionDefinition} from "../document/components/pdf/annotation/AnnotationStrikeFunction";
import {RedactTextFunctionDefinition} from "../document/components/pdf/redact/RedactTextFunction";
import {ConvertDialogDefinition} from "../dialog/components/convert/ConvertDialog";
import {PortfolioCreateDialogDefinition} from "../dialog/components/portfolio/PortfolioCreateDialog";
import {PortalDialogsGlobals} from "../dialog/PortalDialogs";
import FunctionHelper from "../../shared/helper/FunctionHelper";
import {TextLayerGlobals} from "../viewer/pdf/TextLayer";
import {AttachmentDialogDefinition} from "../dialog/components/attachment/AttachmentDialog";
import portalConfiguration from "../../shared/configuration/PortalConfiguration";
import PortalContext from "../PortalContext";
import MenuButton from "../../shared/menu/MenuButton";
import Admin from "../../admin/Admin";
import AbstractMenuBar from "../../shared/menu/AbstractMenuBar";
import {BarcodeCreateDialogDefinition} from "../dialog/components/barcode/BarcodeCreateDialog";
import {BarcodeCreateSwissQrCodeDialogDefinition} from "../dialog/components/barcode/BarcodeCreateSwissQrCodeDialog";
import {CompressionDialogDefinition} from "../dialog/components/document/CompressionDialog";
import {
	BarcodeCreateSwissQrCodeAreaDialogDefinition
} from "../dialog/components/barcode/BarcodeCreateSwissQrCodeAreaDialog";
import {ScaleDialogDefinition} from "../dialog/components/page/ScaleDialog";
import {changeLanguage} from "../../shared/translation/i18n";
import {PortalBarcode} from "../../shared/models/PortalBarcode";
import {PortalToolboxWatermarkWatermark} from "../../shared/models/PortalToolboxWatermarkWatermark";
import {PortalAddSignature} from "../../shared/models/PortalAddSignature";
import {DeleteDocumentType} from "../../shared/models/DeleteDocumentType";
import {HtmlExtractionDialogDefinition} from "../dialog/components/export/HtmlExtractionDialog";
import {HttpRestResponse} from "@softvision/webpdf-wsclient-9-typescript/lib/http/HttpRestResponse";
import {OrientationDialogDefinition} from "../dialog/components/page/OrientationDialog";
import {DocumentSortingGlobals} from "../document/DocumentSorting";
import {DocumentFilterGlobals} from "./DocumentFilterComponent";
import MimeType from "../document/mimetype/MimeType";
import Translate from "../../shared/translation/Translate";
import {PortalSignature} from "../../shared/models/PortalSignature";
import {AnnotationSquigglyFunctionDefinition} from "../document/components/pdf/annotation/AnnotationSquigglyFunction";
import {AnnotationLineFunctionDefinition} from "../document/components/pdf/annotation/AnnotationLineFunction";
import Immutable from "../../shared/immutable/Immutable";
import {SidebarFunctionGlobals} from "../document/components/pdf/SidebarFunctions";
import {AnnotationCircleFunctionDefinition} from "../document/components/pdf/annotation/AnnotationCircleFunction";
import {AnnotationStampFunctionDefinition} from "../document/components/pdf/annotation/AnnotationStampFunction";
import {AnnotationFlattenDialogDefinition} from "../dialog/components/annotation/AnnotationFlattenDialog";
import {PortalToolboxAnnotationAnnotation} from "../../shared/models/PortalToolboxAnnotationAnnotation";
import UserSettings from "../session/UserSettings";
import Icon from "../../shared/components/Icon";
import {PortalGlobals} from "../Portal";
import {DebugGlobals} from "../dialog/components/settings/DebugDialog";
import UnitHelper from "../../shared/helper/UnitHelper";
import LengthUnit from "../../shared/units/LengthUnit";
import ProgressBar from "../../shared/components/ProgressBar";
import FileHelper from "../../shared/helper/FileHelper";
import FileSizeUnit from "../../shared/units/FileSizeUnit";
import {SignatureRemoveDialogDefinition} from "../dialog/components/signature/SignatureRemoveDialog";
import {I18nGlobals, Language} from "../../shared/translation/i18nInterface";
import {ScreenSize} from "../../shared/models/ScreenSize";
import {MenuItem} from "primereact/menuitem";
import {MenuBarProperties} from "../../shared/menu/AbstractMenuBarInterface";
import {MessageLogGlobals} from "../../shared/log/MessageLogInterface";
import FormValues from "../viewer/pdf/form/model/FormValues";
import {FormsEditToolbarFunctionDefinition} from "../viewer/toolbar/FormsEditToolbarFunction";
import {PortalAddToolboxAnnotation} from "../../shared/models/PortalAddToolboxAnnotation";

enum MenuTabs {
	FILE = "file",
	CONVERT = "convert",
	PAGES = "pages",
	WATERMARK = "watermark",
	ATTACHMENT = "attachment",
	SIGNATURE = "signature",
	EXPORT = "export",
	FORM = "form",
	COMMENT = "comment",
	BARCODE = "barcode",
	REDACT = "redact"
}

interface PortalMenuBarProperties extends PortalGlobals, MenuBarProperties, PortalDialogsGlobals, AreaLayerGlobals,
	TextLayerGlobals, MessageLogGlobals, PortalDocumentManagerGlobals, DocumentSortingGlobals, DocumentFilterGlobals,
	SidebarFunctionGlobals, DebugGlobals, I18nGlobals {
	context: PortalContext;
	contentMode: ContentMode;
	userId?: string;
}

interface PortalMenuBarState {
	activeTab: MenuTabs;
	currentZoomValue: number;
	zoomValue: number;
	numberOfPages: number;
	activeMenu: boolean;
}

export class PortalMenuBarDefinition extends AbstractMenuBar<PortalMenuBarProperties, PortalMenuBarState> {
	/**
	 * Constructs a {@link PortalMenuBar} instance
	 */
	constructor(props: Readonly<PortalMenuBarProperties>) {
		super(props);

		this.state = {
			...this.state,
			activeTab: MenuTabs.FILE,
			currentZoomValue: 100,
			zoomValue: 100,
			numberOfPages: 1,
			activeMenu: window.document.documentElement.offsetWidth > ScreenSize.SM
		};

		this.handleKeydown = this.handleKeydown.bind(this);
		this.handleMousePointFunction = this.handleMousePointFunction.bind(this);
		this.handleMouseRectFunction = this.handleMouseRectFunction.bind(this);
		this.handleMouseLineFunction = this.handleMouseLineFunction.bind(this);
		this.throttledZoom = FunctionHelper.throttle(this.throttledZoom.bind(this));
		this.throttledUpdateZoomValue = FunctionHelper.throttle(this.throttledUpdateZoomValue.bind(this));
	}

	/**
	 * This is called when the component is mounted
	 */
	public async componentDidMount(): Promise<void> {
		await super.componentDidMount();

		window.addEventListener('keydown', this.handleKeydown);

		await this.setNumberOfPages();
	}

	/**
	 * This is called when the component is unmounted
	 */
	public async componentWillUnmount(): Promise<void> {
		window.removeEventListener('keydown', this.handleKeydown);
		await super.componentWillUnmount();
	}

	/**
	 * This is called when the components props or state is updated
	 */
	public async componentDidUpdate(
		prevProps: Readonly<PortalMenuBarProperties>, prevState: Readonly<PortalMenuBarState>
	): Promise<void> {
		await super.componentDidUpdate(prevProps, prevState);

		if (this.props.documentSelection.get().length !== 1) {
			return;
		}

		await this.setNumberOfPages();

		let selected: PortalDocument | undefined = this.props.context.documentManager.getSelection().pop();
		if (!FunctionHelper.exists(selected)) {
			return;
		}

		let viewerSettings: DocumentSettings = selected!.getViewerSettings();

		if (this.state.zoomValue !== viewerSettings.activeViewer.zoomValue) {
			this.throttledUpdateZoomValue();
		}

		if (!this.props.textSelection.equals(prevProps.textSelection) && this.props.textSelection?.get().length > 0) {
			this.handleTextSelection();
		}

		if (this.props.mouseFunctionRect !== null && this.props.applyMouseFunction) {
			this.handleMouseRectFunction();
		}

		if (this.props.mouseFunctionPoint !== null && this.props.applyMouseFunction) {
			this.handleMousePointFunction();
		}

		if (this.props.mouseFunctionLine !== null && this.props.applyMouseFunction) {
			this.handleMouseLineFunction();
		}
	}

	private async setNumberOfPages(): Promise<void> {
		if (this.props.documentSelection.get().length !== 1) {
			return;
		}

		let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
		let portalDocument: PortalDocument = this.props.context.documentManager.findDocument(immutable.id!);
		let documentSettings: DocumentSettings = portalDocument.getSettings();
		let numberOfPages: number = 1;

		if (portalDocument.isPortfolioFile()) {
			let attachment: Attachment | undefined =
				portalDocument.getAttachment(documentSettings.portfolioSelection!);

			if (FunctionHelper.exists(attachment)) {
				numberOfPages = await portalDocument.getNumberOfPages(attachment);
			}
		} else {
			numberOfPages = await portalDocument.getNumberOfPages();
		}

		this.setState({
			numberOfPages: numberOfPages
		});
	}

	private throttledUpdateZoomValue(): void {
		if (this.props.documentSelection.get().length !== 1) {
			return;
		}

		let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
		let selected: PortalDocument = this.props.context.documentManager.findDocument(immutable.id!);
		let viewerSettings: DocumentSettings = selected.getViewerSettings();

		this.setState({
			zoomValue: viewerSettings.activeViewer.zoomValue,
			currentZoomValue: viewerSettings.activeViewer.zoomValue
		});
	}

	private handleTextSelection() {
		if (this.props.documentSelection.get().length !== 1) {
			return;
		}

		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
		let selected: PortalDocument = documentManager.findDocument(immutable.id!);
		let viewerSettings: DocumentSettings = selected.getViewerSettings();
		let documentSettings: DocumentSettings = selected.getSettings();

		if (viewerSettings.activeViewer.mouseMode !== MouseMode.SELECT) {
			return;
		}

		let selection: Array<PortalDocument> = documentManager.getSelection();
		let textSelection: Array<Rectangle> = [];
		let page: number = 1;

		for (let selection of FunctionHelper.applyValue(this.props.textSelection?.get(), [])) {
			textSelection.push(Rectangle.fromJson({
				x: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(selection.x, Rectangle.getXDefault()), LengthUnit.MILLIMETER,
					this.props.portalResolution
				),
				y: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(selection.y, Rectangle.getYDefault()), LengthUnit.MILLIMETER,
					this.props.portalResolution
				),
				width: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(selection.width, Rectangle.getWidthDefault()),
					LengthUnit.MILLIMETER, this.props.portalResolution
				),
				height: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(selection.height, Rectangle.getHeightDefault()),
					LengthUnit.MILLIMETER, this.props.portalResolution
				),
				metrics: Metrics.Mm
			} as RectangleInterface));
			page = selection.page;
		}

		switch (viewerSettings.activeViewer.mouseFunction) {
			case MouseFunction.MARK:
				let annotationMarkParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationMarkParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_MARK, selection);

				if (FunctionHelper.applyValue(
					annotationMarkParameter.data.add?.markup, AddToolboxAnnotation.getMarkupDefault()
				).length === 0) {
					break;
				}

				annotationMarkParameter.data.add!.markup![0].page = page;
				annotationMarkParameter.data.add!.markup![0].position!.pathElement = textSelection;

				this.props.context.getPage().setState({
					annotationMarkParameter: annotationMarkParameter,
					showAnnotationMarkFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.UNDERLINE:
				let annotationUnderlineParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationUnderlineParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_UNDERLINE, selection);

				if (FunctionHelper.applyValue(
					annotationUnderlineParameter.data.add?.markup, AddToolboxAnnotation.getMarkupDefault()
				).length === 0) {
					break;
				}

				annotationUnderlineParameter.data.add!.markup![0].page = page;
				annotationUnderlineParameter.data.add!.markup![0].position!.pathElement = textSelection;

				this.props.context.getPage().setState({
					annotationUnderlineParameter: annotationUnderlineParameter,
					showAnnotationUnderlineFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.STRIKE:
				let annotationStrikeParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationStrikeParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_STRIKE, selection);

				if (FunctionHelper.applyValue(
					annotationStrikeParameter.data.add?.markup, AddToolboxAnnotation.getMarkupDefault()
				).length === 0) {
					break;
				}

				annotationStrikeParameter.data.add!.markup![0].page = page;
				annotationStrikeParameter.data.add!.markup![0].position!.pathElement = textSelection;

				this.props.context.getPage().setState({
					annotationStrikeParameter: annotationStrikeParameter,
					showAnnotationStrikeFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.REDACT_TEXT:
				let redactTextParameter: Parameter<PortalToolboxAnnotationAnnotation> =
					this.props.redactTextParameter ||
					DialogDefault.getParameter(PortalDialogType.REDACT_TEXT, selection);

				if (FunctionHelper.applyValue(
					redactTextParameter.data.add?.redact, PortalAddToolboxAnnotation.getRedactDefault()
				).length === 0) {
					break;
				}

				redactTextParameter.data.add!.redact![0].page = page;
				redactTextParameter.data.add!.redact![0].position!.pathElement = textSelection;

				this.props.context.getPage().setState({
					redactTextParameter: redactTextParameter,
					showRedactTextFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.SQUIGGLY:
				let annotationSquigglyParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationSquigglyParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_SQUIGGLY, selection);

				if (FunctionHelper.applyValue(
					annotationSquigglyParameter.data.add?.markup, AddToolboxAnnotation.getMarkupDefault()
				).length === 0) {
					break;
				}

				annotationSquigglyParameter.data.add!.markup![0].page = page;
				annotationSquigglyParameter.data.add!.markup![0].position!.pathElement = textSelection;

				this.props.context.getPage().setState({
					annotationSquigglyParameter: annotationSquigglyParameter,
					showAnnotationSquigglyFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
		}

		this.props.context.getPage().setState({
			updateSidebarFunction: Date.now()
		});
	}

	private handleMousePointFunction() {
		this.props.context.getPage().setState({
			applyMouseFunction: false
		});

		if (this.props.documentSelection.get().length !== 1 || !FunctionHelper.exists(this.props.mouseFunctionPoint)) {
			return;
		}

		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
		let selected: PortalDocument = documentManager.findDocument(immutable.id!);
		let viewerSettings: DocumentSettings = selected.getViewerSettings();

		if (viewerSettings.activeViewer.mouseMode !== MouseMode.POINT) {
			return;
		}

		let selection: Array<PortalDocument> = documentManager.getSelection();
		let mouseFunctionPoint: Point = Point.fromJson(this.props.mouseFunctionPoint!.get());
		let page: number = this.props.mouseFunctionPoint!.get().page;

		let positionParameter: Point = Point.fromJson({
			x: UnitHelper.pxToUnit(
				FunctionHelper.applyValue(mouseFunctionPoint.x, Point.getXDefault()), LengthUnit.MILLIMETER,
				this.props.portalResolution
			),
			y: UnitHelper.pxToUnit(
				FunctionHelper.applyValue(mouseFunctionPoint.y, Point.getYDefault()), LengthUnit.MILLIMETER,
				this.props.portalResolution
			),
			metrics: Metrics.Mm
		});

		switch (viewerSettings.activeViewer.mouseFunction) {
			case MouseFunction.ATTACHMENT:
				let attachmentParameter: Parameter<ToolboxAttachmentAttachment> =
					DialogDefault.getParameter(PortalDialogType.ATTACHMENT_ADD, selection);

				attachmentParameter.data.add!.file![0].annotation!.page = page;
				attachmentParameter.data.add!.file![0].annotation!.point = positionParameter;

				this.props.context.getPage().setState({
					attachmentParameter: attachmentParameter,
					showAttachmentDialog: true
				});
				break;
		}
	}

	private handleMouseRectFunction() {
		this.props.context.getPage().setState({
			applyMouseFunction: false
		});

		if (this.props.documentSelection.get().length !== 1 || !FunctionHelper.exists(this.props.mouseFunctionRect)) {
			return;
		}

		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
		let selected: PortalDocument = documentManager.findDocument(immutable.id!);
		let viewerSettings: DocumentSettings = selected.getViewerSettings();
		let documentSettings: DocumentSettings = selected.getSettings();

		if (viewerSettings.activeViewer.mouseMode !== MouseMode.RECTANGLE) {
			return;
		}

		let selection: Array<PortalDocument> = documentManager.getSelection();
		let mouseFunctionRect: Rectangle = Rectangle.fromJson(this.props.mouseFunctionRect!.get());
		let barcodeCreateParameter: Parameter<PortalBarcode>;
		let page: number = this.props.mouseFunctionRect!.get().page;

		let positionParameter: Rectangle = Rectangle.fromJson({
			x: UnitHelper.pxToUnit(
				FunctionHelper.applyValue(mouseFunctionRect.x, Rectangle.getXDefault()), LengthUnit.MILLIMETER,
				this.props.portalResolution
			),
			y: UnitHelper.pxToUnit(
				FunctionHelper.applyValue(mouseFunctionRect.y, Rectangle.getYDefault()), LengthUnit.MILLIMETER,
				this.props.portalResolution
			),
			width: UnitHelper.pxToUnit(
				FunctionHelper.applyValue(mouseFunctionRect.width, Rectangle.getWidthDefault()),
				LengthUnit.MILLIMETER, this.props.portalResolution
			),
			height: UnitHelper.pxToUnit(
				FunctionHelper.applyValue(mouseFunctionRect.height, Rectangle.getHeightDefault()),
				LengthUnit.MILLIMETER, this.props.portalResolution
			),
			metrics: Metrics.Mm
		} as Rectangle);

		switch (viewerSettings.activeViewer.mouseFunction) {
			case MouseFunction.BARCODE_CREATE:
				barcodeCreateParameter = DialogDefault.getParameter(
					PortalDialogType.BARCODE_CREATE_AREA, selection
				);

				barcodeCreateParameter.data.add!.qrcode![0].pages = page.toString();
				barcodeCreateParameter.data.add!.qrcode![0].position = positionParameter;
				barcodeCreateParameter.data.add!.aztec![0].pages = page.toString();
				barcodeCreateParameter.data.add!.aztec![0].position = positionParameter;
				barcodeCreateParameter.data.add!.codabar![0].pages = page.toString();
				barcodeCreateParameter.data.add!.codabar![0].position = positionParameter;
				barcodeCreateParameter.data.add!.code128![0].pages = page.toString();
				barcodeCreateParameter.data.add!.code128![0].position = positionParameter;
				barcodeCreateParameter.data.add!.code39![0].pages = page.toString();
				barcodeCreateParameter.data.add!.code39![0].position = positionParameter;
				barcodeCreateParameter.data.add!.datamatrix![0].pages = page.toString();
				barcodeCreateParameter.data.add!.datamatrix![0].position = positionParameter;
				barcodeCreateParameter.data.add!.ean13![0].pages = page.toString();
				barcodeCreateParameter.data.add!.ean13![0].position = positionParameter;
				barcodeCreateParameter.data.add!.ean8![0].pages = page.toString();
				barcodeCreateParameter.data.add!.ean8![0].position = positionParameter;
				barcodeCreateParameter.data.add!.itf![0].pages = page.toString();
				barcodeCreateParameter.data.add!.itf![0].position = positionParameter;
				barcodeCreateParameter.data.add!.pdf417![0].pages = page.toString();
				barcodeCreateParameter.data.add!.pdf417![0].position = positionParameter;
				barcodeCreateParameter.data.add!.upca![0].pages = page.toString();
				barcodeCreateParameter.data.add!.upca![0].position = positionParameter;

				this.props.context.getPage().setState({
					barcodeCreateAreaParameter: barcodeCreateParameter,
					showBarcodeCreateAreaDialog: true
				});
				break;
			case MouseFunction.BARCODE_CREATE_SWISS_CODE:
				barcodeCreateParameter = DialogDefault.getParameter(
					PortalDialogType.BARCODE_CREATE_SWISS_QR_AREA, selection
				);

				barcodeCreateParameter.data.add!.qrswiss![0].pdf!.page = page;
				barcodeCreateParameter.data.add!.qrswiss![0].format = QrSwissPaymentFormat.CodeOnly;
				barcodeCreateParameter.data.add!.qrswiss![0].position = positionParameter;

				this.props.context.getPage().setState({
					barcodeCreateSwissQrAreaParameter: barcodeCreateParameter,
					showBarcodeCreateSwissQrAreaDialog: true
				});
				break;
			case MouseFunction.BARCODE_CREATE_SWISS_BILL:
				barcodeCreateParameter = DialogDefault.getParameter(
					PortalDialogType.BARCODE_CREATE_SWISS_QR_AREA, selection
				);

				barcodeCreateParameter.data.add!.qrswiss![0].pdf!.page = page;
				barcodeCreateParameter.data.add!.qrswiss![0].format = QrSwissPaymentFormat.BillOnly;
				barcodeCreateParameter.data.add!.qrswiss![0].position = positionParameter;

				this.props.context.getPage().setState({
					barcodeCreateSwissQrAreaParameter: barcodeCreateParameter,
					showBarcodeCreateSwissQrAreaDialog: true
				});
				break;
			case MouseFunction.BARCODE_CREATE_SWISS_BILL_WITH_SPACE:
				barcodeCreateParameter = DialogDefault.getParameter(
					PortalDialogType.BARCODE_CREATE_SWISS_QR_AREA, selection
				);

				barcodeCreateParameter.data.add!.qrswiss![0].pdf!.page = page;
				barcodeCreateParameter.data.add!.qrswiss![0].format = QrSwissPaymentFormat.BillExtraSpace;
				barcodeCreateParameter.data.add!.qrswiss![0].position = positionParameter;

				this.props.context.getPage().setState({
					barcodeCreateSwissQrAreaParameter: barcodeCreateParameter,
					showBarcodeCreateSwissQrAreaDialog: true
				});
				break;
			case MouseFunction.BARCODE_DETECT:
				let barcodeDetectParameter: Parameter<PortalBarcode> =
					DialogDefault.getParameter(PortalDialogType.BARCODE_DETECT, selection);
				barcodeDetectParameter.data.detect!.selection![0].pages = page.toString();
				barcodeDetectParameter.data.detect!.selection![0].scanArea = positionParameter;

				this.props.context.getPage().setState({
					barcodeDetectParameter: barcodeDetectParameter,
					showBarcodeDetectDialog: true
				});
				break;
			case MouseFunction.WATERMARK:
				let watermarkParameter: Parameter<PortalToolboxWatermarkWatermark> =
					DialogDefault.getParameter(PortalDialogType.WATERMARK, selection);
				watermarkParameter.data.pages = page.toString();
				watermarkParameter.data.text!.position = WatermarkPosition.fromJson({
					...positionParameter,
					position: WatermarkPositionMode.Custom
				} as WatermarkPosition);
				watermarkParameter.data.image!.position = WatermarkPosition.fromJson({
					...positionParameter,
					position: WatermarkPositionMode.Custom
				} as WatermarkPosition);

				this.props.context.getPage().setState({
					watermarkParameter: watermarkParameter,
					showWatermarkDialog: true
				});
				break;
			case MouseFunction.REDACT_AREA:
				let redactAreaParameter: Parameter<PortalToolboxAnnotationAnnotation> =
					this.props.redactAreaParameter ||
					DialogDefault.getParameter(PortalDialogType.REDACT_AREA, selection);

				if (FunctionHelper.applyValue(
					redactAreaParameter.data.add?.redact, PortalAddToolboxAnnotation.getRedactDefault()
				).length === 0) {
					break;
				}

				redactAreaParameter.data.add!.redact![0].page = page;
				redactAreaParameter.data.add!.redact![0].position!.pathElement = [positionParameter];

				this.props.context.getPage().setState({
					redactAreaParameter: redactAreaParameter,
					showRedactAreaFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.SIGNATURE:
				let signatureParameter: Parameter<PortalSignature> =
					DialogDefault.getParameter(PortalDialogType.SIGNATURE, selection);
				let addParameter: PortalAddSignature =
					signatureParameter.data.add as PortalAddSignature;

				if (!FunctionHelper.exists(addParameter.appearance)) {
					addParameter.appearance = new AppearanceAdd({});
				}

				addParameter.appearance!.page = page;
				addParameter.appearance!.position = SignaturePosition.fromJson({
					...positionParameter
				} as SignaturePosition);

				addParameter.fieldName = "";
				addParameter.visible = true;
				signatureParameter.data.add = addParameter;

				this.props.context.getPage().setState({
					signatureParameter: signatureParameter,
					showSignatureDialog: true
				});
				break;
			case MouseFunction.SQUARE:
				let annotationSquareParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationSquareParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_SQUARE, selection);

				if (FunctionHelper.applyValue(
					annotationSquareParameter.data.add?.square, AddToolboxAnnotation.getSquareDefault()
				).length === 0) {
					break;
				}

				annotationSquareParameter.data.add!.square![0].page = page;
				annotationSquareParameter.data.add!.square![0].position = PositionSimpleShapeAnnotation.fromJson({
					rectangle: positionParameter
				} as PositionSimpleShapeAnnotationInterface);

				this.props.context.getPage().setState({
					annotationSquareParameter: annotationSquareParameter,
					showAnnotationSquareFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.CIRCLE:
				let annotationCircleParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationCircleParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_CIRCLE, selection);

				if (FunctionHelper.applyValue(
					annotationCircleParameter.data.add?.circle, AddToolboxAnnotation.getCircleDefault()
				).length === 0) {
					break;
				}

				annotationCircleParameter.data.add!.circle![0].page = page;
				annotationCircleParameter.data.add!.circle![0].position = PositionSimpleShapeAnnotation.fromJson({
					rectangle: positionParameter
				} as PositionSimpleShapeAnnotationInterface);

				this.props.context.getPage().setState({
					annotationCircleParameter: annotationCircleParameter,
					showAnnotationCircleFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.STAMP_APPROVED:
			case MouseFunction.STAMP_EXPERIMENTAL:
			case MouseFunction.STAMP_NOT_APPROVED:
			case MouseFunction.STAMP_AS_IS:
			case MouseFunction.STAMP_EXPIRED:
			case MouseFunction.STAMP_NOT_FOR_PUBLIC_RELEASE:
			case MouseFunction.STAMP_CONFIDENTIAL:
			case MouseFunction.STAMP_FINAL:
			case MouseFunction.STAMP_SOLD:
			case MouseFunction.STAMP_DEPARTMENTAL:
			case MouseFunction.STAMP_FOR_COMMENT:
			case MouseFunction.STAMP_TOP_SECRET:
			case MouseFunction.STAMP_DRAFT:
			case MouseFunction.STAMP_FOR_PUBLIC_RELEASE:
			case MouseFunction.STAMP_CUSTOM:
				let annotationStampParameter: Parameter<PortalToolboxAnnotationAnnotation> =
					this.props.annotationStampParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);

				if (FunctionHelper.applyValue(
					annotationStampParameter.data.add?.rubberstamp, AddToolboxAnnotation.getRubberstampDefault()
				).length === 0) {
					break;
				}

				annotationStampParameter.data.add!.rubberstamp![0].page = page;
				annotationStampParameter.data.add!.rubberstamp![0].position = PositionRubberStampAnnotation.fromJson({
					rectangle: positionParameter
				} as PositionRubberStampAnnotationInterface);

				switch (viewerSettings.activeViewer.mouseFunction) {
					case MouseFunction.STAMP_APPROVED:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Approved;
						break;
					case MouseFunction.STAMP_EXPERIMENTAL:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Experimental;
						break;
					case MouseFunction.STAMP_NOT_APPROVED:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.NotApproved;
						break;
					case MouseFunction.STAMP_AS_IS:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.AsIs;
						break;
					case MouseFunction.STAMP_EXPIRED:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Expired;
						break;
					case MouseFunction.STAMP_NOT_FOR_PUBLIC_RELEASE:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.NotForPublicRelease;
						break;
					case MouseFunction.STAMP_CONFIDENTIAL:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Confidential;
						break;
					case MouseFunction.STAMP_FINAL:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Final;
						break;
					case MouseFunction.STAMP_SOLD:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Sold;
						break;
					case MouseFunction.STAMP_DEPARTMENTAL:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Departmental;
						break;
					case MouseFunction.STAMP_FOR_COMMENT:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.ForComment;
						break;
					case MouseFunction.STAMP_TOP_SECRET:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.TopSecret;
						break;
					case MouseFunction.STAMP_DRAFT:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Draft;
						break;
					case MouseFunction.STAMP_FOR_PUBLIC_RELEASE:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.ForPublicRelease;
						break;
					case MouseFunction.STAMP_CUSTOM:
						annotationStampParameter.data.add!.rubberstamp![0].icon = RubberStampIcon.Unnamed;
						break;
				}

				this.props.context.getPage().setState({
					annotationStampParameter: annotationStampParameter,
					showAnnotationStampFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
			case MouseFunction.NOTE:
				let annotationNoteParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationNoteParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_NOTE, selection);

				if (FunctionHelper.applyValue(
					annotationNoteParameter.data.add?.text, AddToolboxAnnotation.getTextDefault()
				).length === 0) {
					break;
				}

				annotationNoteParameter.data.add!.text![0].page = page;
				annotationNoteParameter.data.add!.text![0].position = positionParameter;

				this.props.context.getPage().setState({
					annotationNoteParameter: annotationNoteParameter,
					showAnnotationNoteFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
		}
	}

	private handleMouseLineFunction() {
		this.props.context.getPage().setState({
			applyMouseFunction: false
		});

		if (this.props.documentSelection.get().length !== 1 || !FunctionHelper.exists(this.props.mouseFunctionLine)) {
			return;
		}

		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
		let selected: PortalDocument = documentManager.findDocument(immutable.id!);
		let viewerSettings: DocumentSettings = selected.getViewerSettings();
		let documentSettings: DocumentSettings = selected.getSettings();

		if (viewerSettings.activeViewer.mouseMode !== MouseMode.POINT) {
			return;
		}

		let selection: Array<PortalDocument> = documentManager.getSelection();
		let mouseFunctionLine: LineAnnotation =
			LineAnnotation.fromJson(this.props.mouseFunctionLine!.get());
		let page: number = this.props.mouseFunctionLine!.get().page;

		let positionParameter: LineAnnotation = LineAnnotation.fromJson({
			start: Point.fromJson({
				x: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(mouseFunctionLine.start.x, Point.getXDefault()), LengthUnit.MILLIMETER,
					this.props.portalResolution
				),
				y: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(mouseFunctionLine.start.y, Point.getYDefault()), LengthUnit.MILLIMETER,
					this.props.portalResolution
				),
				metrics: Metrics.Mm
			}),
			end: Point.fromJson({
				x: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(mouseFunctionLine.end.x, Point.getXDefault()), LengthUnit.MILLIMETER,
					this.props.portalResolution
				),
				y: UnitHelper.pxToUnit(
					FunctionHelper.applyValue(mouseFunctionLine.end.y, Point.getYDefault()), LengthUnit.MILLIMETER,
					this.props.portalResolution
				),
				metrics: Metrics.Mm
			})
		} as LineAnnotationInterface);

		switch (viewerSettings.activeViewer.mouseFunction) {
			case MouseFunction.LINE:
				let annotationLineParameter: Parameter<ToolboxAnnotationAnnotation> =
					this.props.annotationLineParameter ||
					DialogDefault.getParameter(PortalDialogType.ANNOTATION_LINE, selection);

				if (FunctionHelper.applyValue(
					annotationLineParameter.data.add?.line, AddToolboxAnnotation.getLineDefault()
				).length === 0) {
					break;
				}

				annotationLineParameter.data.add!.line![0].page = page;
				annotationLineParameter.data.add!.line![0].start = positionParameter.start;
				annotationLineParameter.data.add!.line![0].end = positionParameter.end;

				this.props.context.getPage().setState({
					annotationLineParameter: annotationLineParameter,
					showAnnotationLineFunction: true
				}, () => {
					documentSettings.showSidebarFunction = true;
					documentManager.updateGlobalDocumentList();
				});
				break;
		}
	}

	/**
	 * Handle documents download button click
	 */
	private async downloadDocuments(mode?: "single" | "zip"): Promise<void> {
		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let documentSelection: Array<PortalDocument> = documentManager.getSelection();
		let downloader: Downloader = new Downloader(this.props.context.session.getToken()!);

		if (mode !== "zip" && (documentSelection.length === 1 || mode === "single")) {
			for (let selectedDocument of documentSelection) {
				await downloader.downloadDocument(
					selectedDocument.getSourceDocumentId() as string,
					selectedDocument.getDocumentFile()?.fileName as string
				);
			}
		} else {
			let entries: Array<{ name: string, extension?: string, data: any }> = [];

			for (let selectedDocument of documentSelection) {
				let response: HttpRestResponse = await documentManager.downloadDocument(
					selectedDocument.getSourceDocumentId()!
				);

				entries.push({
					name: selectedDocument.getDocumentFile()!.fileName!,
					extension: selectedDocument.getDocumentFile()?.fileExtension,
					data: await response.getData()
				});
			}

			await downloader.downloadDocuments(entries);
		}
	}

	/**
	 * Defers a zoom request if another one is currently queued. required for slider inputs
	 */
	private setZoom(value: number): void {
		this.setState({
			currentZoomValue: value
		});

		this.throttledZoom(value);
	}

	/**
	 * Sets a custom zoom value in the context settings
	 */
	private throttledZoom(value: number) {
		if (this.props.documentSelection.get().length !== 1) {
			return;
		}

		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
		let selected: PortalDocument = documentManager.findDocument(immutable.id!);
		let viewerSettings: DocumentSettings = selected.getViewerSettings();
		viewerSettings.activeViewer.zoomMode = ZoomMode.CUSTOM;
		viewerSettings.activeViewer.zoomValue = value;

		documentManager.updateGlobalDocumentList();
	}

	private getCurrentSettings(viewerSettings: boolean = false): DocumentSettings | undefined {
		if (this.props.documentSelection.get().length === 1) {
			let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
			let selected: PortalDocument = this.props.context.documentManager.findDocument(immutable.id!);

			if (viewerSettings) {
				return selected.getViewerSettings();
			}

			return selected.getSettings();
		}

		return undefined;
	}

	/**
	 * Handles keyboard key down events
	 */
	private async handleKeydown(e: KeyboardEvent): Promise<void> {
		switch (e.key.toLowerCase()) {
			case "escape":
				await DocumentSettings.resetMouseFunction(this.props);
				break;
		}
	}

	private setMouseMode(settings: DocumentSettings, mouseMode: MouseMode, mouseFunction?: MouseFunction): void {
		if (FunctionHelper.exists(mouseFunction)) {
			if (settings.activeViewer.mouseMode === mouseMode && settings.activeViewer.mouseFunction === mouseFunction) {
				settings!.resetMouseMode();
			} else {
				settings.activeViewer.mouseMode = mouseMode;
				settings.activeViewer.mouseFunction = mouseFunction!;
			}

			return;
		}

		settings.activeViewer.mouseMode = settings.activeViewer.mouseMode === mouseMode ? MouseMode.MOVE : mouseMode;
	}

	/**
	 * Renders Viewer settings
	 * @private
	 */
	private renderDocumentSettings(): ReactNode {
		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let viewerSettings: DocumentSettings | undefined = this.getCurrentSettings(true);
		let currentPage: number = 1;
		let pageCount: number = 1;
		let hasMouseModes: boolean = false;
		let hasPageModes: boolean = false;
		let hasZoom: boolean = false;
		let fileLocked: boolean = false;

		if (this.props.documentSelection.get().length === 1 && FunctionHelper.exists(viewerSettings)) {
			let immutable: PortalDocumentInterface = this.props.documentSelection.get().pop()!;
			let selected: PortalDocument = documentManager.findDocument(immutable.id!);
			let documentSettings: DocumentSettings = selected.getSettings();
			currentPage = viewerSettings!.activeViewer.currentPage;
			pageCount = this.state.numberOfPages;

			let isFolderSelected: boolean = FunctionHelper.exists(selected.getFolderByPath(
				FunctionHelper.applyValue(documentSettings.portfolioSelection, "")
			));
			let selectedAttachment: Attachment | undefined = selected.getAttachment(
				!isFolderSelected ? FunctionHelper.applyValue(documentSettings.portfolioSelection, "") : ""
			);
			let mimetype: MimeType = selected.getMimeType(selectedAttachment);

			hasMouseModes = MimeTypeFilter.check(mimetype, [MimeTypes.PDF]);
			hasPageModes = MimeTypeFilter.check(mimetype, [MimeTypes.PDF]);
			hasZoom = MimeTypeFilter.check(mimetype, [MimeTypes.IMAGE, MimeTypes.PDF]);
			fileLocked = selected.isLocked();
		}

		let viewerActive: boolean = this.props.contentMode === ContentMode.VIEWER
		let hasPreviousPage: boolean = currentPage > 1;
		let hasNextPage: boolean = currentPage < pageCount;
		let hasPages: boolean = pageCount > 1;

		let mouseModeIcon: Array<string> = ["icon"];
		let mouseModeLabel: string;
		switch (viewerSettings?.activeViewer.mouseMode) {
			case MouseMode.MOVE:
				mouseModeIcon.push("icon-hand");
				mouseModeLabel = Translate.value("mouse.move.label", {ns: "menu"});
				break;
			case MouseMode.TEXT:
				mouseModeIcon.push("icon-pointer");
				mouseModeLabel = Translate.value("mouse.select.label", {ns: "menu"});
				break;
			case MouseMode.ZOOM:
				mouseModeIcon.push("icon-zoom-area");
				mouseModeLabel = Translate.value("mouse.zoom.label", {ns: "menu"});
				break;
			default:
				mouseModeIcon.push("icon-hand");
				mouseModeLabel = Translate.value("mouse.move.label", {ns: "menu"});
				break;
		}

		let pageModeIcon: Array<string> = ["icon"];
		let pageModeLabel: string;
		switch (viewerSettings?.activeViewer.pageMode) {
			case PageViewMode.SINGLE:
				pageModeIcon.push("icon-page");
				pageModeLabel = Translate.value("page.single.label", {ns: "menu"});
				break;
			case PageViewMode.DUAL:
				pageModeIcon.push("icon-dual");
				pageModeLabel = Translate.value("page.dual.label", {ns: "menu"});
				break;
			default:
				pageModeIcon.push("icon-page");
				pageModeLabel = Translate.value("page.single.label", {ns: "menu"});
				break;
		}

		let zoomModeIcon: Array<string> = ["icon"];
		let zoomModeLabel: string;
		switch (viewerSettings?.activeViewer.zoomMode) {
			case ZoomMode.PAGE:
				zoomModeIcon.push("icon-zoom-fit");
				zoomModeLabel = Translate.value("zoom.fit.label", {ns: "menu"});
				break;
			case ZoomMode.WIDTH:
				zoomModeIcon.push("icon-zoom-width");
				zoomModeLabel = Translate.value("zoom.width.label", {ns: "menu"});
				break;
			case ZoomMode.HEIGHT:
				zoomModeIcon.push("icon-zoom-height");
				zoomModeLabel = Translate.value("zoom.height.label", {ns: "menu"});
				break;
			case ZoomMode.ORIGINAL:
				zoomModeIcon.push("icon-zoom-original");
				zoomModeLabel = Translate.value("zoom.original.label", {ns: "menu"});
				break;
			default:
				zoomModeIcon.push("icon-zoom-fit");
				zoomModeLabel = Translate.value("zoom.fit.label", {ns: "menu"});
				break;
		}

		return (
			<>
				<div className="menu-block mobile">
					<div className="menu-group small">
						<MenuButton {...this.props} disabled={!viewerActive || !hasMouseModes || fileLocked}
									icon={mouseModeIcon.join(" ")} label={mouseModeLabel}
									data-help="global.menu.mouse" data-position="right"
									menuItems={[
										{
											icon: "icon icon-hand",
											label: Translate.value("mouse.move.label", {ns: "menu"}),
											disabled: !viewerActive || !hasMouseModes,
											className: viewerActive && hasMouseModes &&
											viewerSettings?.activeViewer.mouseMode === MouseMode.MOVE ? "active" : "",
											command: async () => {
												let command: () => Promise<void> = async () => {
													let viewerSettings: DocumentSettings | undefined =
														this.getCurrentSettings(true);
													if (!FunctionHelper.exists(viewerSettings)) {
														return;
													}

													viewerSettings!.resetMouseMode();
													viewerSettings!.activeViewer.mouseMode = MouseMode.MOVE;
													documentManager.updateGlobalDocumentList();
												}

												if (DocumentSettings.checkActiveMouseFunction(this.props)) {
													DocumentSettings.confirmResetMouseFunction(this.props, command);
													return;
												}

												await command();
											}
										},
										{
											icon: "icon icon-pointer",
											label: Translate.value("mouse.select.label", {ns: "menu"}),
											disabled: !viewerActive || !hasMouseModes,
											className: viewerActive && hasMouseModes &&
											viewerSettings?.activeViewer.mouseMode === MouseMode.TEXT ? "active" : "",
											command: async () => {
												let command: () => Promise<void> = async () => {
													let viewerSettings: DocumentSettings | undefined =
														this.getCurrentSettings(true);
													if (!FunctionHelper.exists(viewerSettings)) {
														return;
													}

													viewerSettings!.resetMouseMode();
													viewerSettings!.activeViewer.mouseMode = MouseMode.TEXT;
													documentManager.updateGlobalDocumentList();
												}

												if (DocumentSettings.checkActiveMouseFunction(this.props)) {
													DocumentSettings.confirmResetMouseFunction(this.props, command);
													return;
												}

												await command();
											}
										},
										{
											icon: "icon icon-zoom-area",
											label: Translate.value("mouse.zoom.label", {ns: "menu"}),
											disabled: !viewerActive || !hasMouseModes,
											className: viewerActive && hasMouseModes &&
											viewerSettings?.activeViewer.mouseMode === MouseMode.ZOOM ? "active" : "",
											command: async () => {
												let command: () => Promise<void> = async () => {
													let viewerSettings: DocumentSettings | undefined =
														this.getCurrentSettings(true);
													if (!FunctionHelper.exists(viewerSettings)) {
														return;
													}

													viewerSettings!.resetMouseMode();
													viewerSettings!.activeViewer.mouseMode = MouseMode.ZOOM;
													documentManager.updateGlobalDocumentList();
												}

												if (DocumentSettings.checkActiveMouseFunction(this.props)) {
													DocumentSettings.confirmResetMouseFunction(this.props, command);
													return;
												}

												await command();
											}
										}
									]}/>
						<MenuButton {...this.props} disabled={!viewerActive || !hasPageModes || fileLocked}
									icon={pageModeIcon.join(" ")} label={pageModeLabel}
									data-help="global.menu.page" data-position="right"
									menuItems={[
										{
											icon: "icon icon-page",
											label: Translate.value("page.single.label", {ns: "menu"}),
											disabled: !viewerActive || !hasPageModes,
											className: viewerActive && hasPageModes &&
											viewerSettings?.activeViewer.pageMode === PageViewMode.SINGLE ?
												"active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.pageMode = PageViewMode.SINGLE;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-dual",
											label: Translate.value("page.dual.label", {ns: "menu"}),
											disabled: !viewerActive || !hasPageModes,
											className: viewerActive && hasPageModes &&
											viewerSettings?.activeViewer.pageMode === PageViewMode.DUAL ?
												"active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.pageMode = PageViewMode.DUAL;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-scrolling",
											label: Translate.value("page.continuous.label", {ns: "menu"}),
											disabled: !viewerActive || !hasPageModes,
											className: viewerActive && viewerSettings?.activeViewer.continuous &&
											hasPageModes ? "active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.continuous =
													!viewerSettings?.activeViewer.continuous;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-page-cover",
											label: Translate.value("page.cover.label", {ns: "menu"}),
											disabled: !viewerActive || !hasPageModes ||
												viewerSettings?.activeViewer.pageMode !== PageViewMode.DUAL,
											className: viewerActive && viewerSettings?.activeViewer.pageCover &&
											hasPageModes && viewerSettings?.activeViewer.pageMode === PageViewMode.DUAL ?
												"active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.pageCover =
													!viewerSettings!.activeViewer.pageCover;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-page-padding",
											label: Translate.value("page.padding.label", {ns: "menu"}),
											disabled: !viewerActive || !hasPageModes ||
												viewerSettings?.activeViewer.pageMode !== PageViewMode.DUAL,
											className: viewerActive && viewerSettings?.activeViewer.pagePadding &&
											hasPageModes && viewerSettings?.activeViewer.pageMode === PageViewMode.DUAL ?
												"active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.pagePadding =
													!viewerSettings!.activeViewer.pagePadding;
												documentManager.updateGlobalDocumentList();
											}
										}
									]}/>
						<MenuButton {...this.props} disabled={!viewerActive || !hasZoom || fileLocked}
									icon={zoomModeIcon.join(" ")} label={zoomModeLabel}
									data-help="global.menu.zoom" data-position="right"
									menuItems={[
										{
											icon: "icon icon-zoom-fit",
											label: Translate.value("zoom.fit.label", {ns: "menu"}),
											disabled: !viewerActive || !hasZoom,
											className: viewerActive &&
											viewerSettings?.activeViewer.zoomMode === ZoomMode.PAGE ? "active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.zoomMode = ZoomMode.PAGE;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-zoom-width",
											label: Translate.value("zoom.width.label", {ns: "menu"}),
											disabled: !viewerActive || !hasZoom,
											className: viewerActive &&
											viewerSettings?.activeViewer.zoomMode === ZoomMode.WIDTH ? "active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.zoomMode = ZoomMode.WIDTH;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-zoom-height",
											label: Translate.value("zoom.height.label", {ns: "menu"}),
											disabled: !viewerActive || !hasZoom,
											className: viewerActive &&
											viewerSettings?.activeViewer.zoomMode === ZoomMode.HEIGHT ? "active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.zoomMode = ZoomMode.HEIGHT;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-zoom-original",
											label: Translate.value("zoom.original.label", {ns: "menu"}),
											disabled: !viewerActive || !hasZoom,
											className: viewerActive &&
											viewerSettings?.activeViewer.zoomMode === ZoomMode.ORIGINAL ? "active" : "",
											command: async () => {
												let viewerSettings: DocumentSettings | undefined =
													this.getCurrentSettings(true);
												if (!FunctionHelper.exists(viewerSettings)) {
													return;
												}

												viewerSettings!.activeViewer.zoomMode = ZoomMode.ORIGINAL;
												documentManager.updateGlobalDocumentList();
											}
										},
										{
											icon: "icon icon-zoom-fullscreen",
											label: Translate.value("zoom.fullscreen.label", {ns: "menu"}),
											disabled: !viewerActive || !hasZoom || !document.fullscreenEnabled,
											command: async () => {
												let command: () => Promise<void> = async () => {
													let viewerSettings: DocumentSettings | undefined =
														this.getCurrentSettings(true);
													if (!FunctionHelper.exists(viewerSettings)) {
														return;
													}

													viewerSettings!.fullscreen = true;
													viewerSettings!.resetMouseMode();
													viewerSettings!.fullscreenSettings.mouseMode = MouseMode.MOVE;
													viewerSettings!.fullscreenSettings.continuous = false;
													viewerSettings!.fullscreenSettings.pageMode = PageViewMode.SINGLE;
													documentManager.updateGlobalDocumentList();
												}

												if (DocumentSettings.checkActiveMouseFunction(this.props)) {
													DocumentSettings.confirmResetMouseFunction(this.props, command);
													return;
												}

												await command();
											}
										}
									]}/>
					</div>
					<div className="menu-function">
						<div className="p-inputgroup zoom">
							<MenuButton {...this.props} icon="icon icon-angle-down"
										disabled={!viewerActive || !hasZoom || fileLocked}
										menuItems={
											[
												{label: "10 %", command: () => this.setZoom(10)},
												{label: "25 %", command: () => this.setZoom(25)},
												{label: "50 %", command: () => this.setZoom(50)},
												{label: "75 %", command: () => this.setZoom(75)},
												{label: "100 %", command: () => this.setZoom(100)},
												{label: "125 %", command: () => this.setZoom(125)},
												{label: "150 %", command: () => this.setZoom(150)},
												{label: "200 %", command: () => this.setZoom(200)},
												{label: "400 %", command: () => this.setZoom(400)},
											]
										}/>
							<InputNumber max={400} min={10} disabled={!viewerActive || !hasZoom || fileLocked}
										 onValueChange={(e) => this.setZoom(
											 FunctionHelper.applyValue(e.value, 100)
										 )}
										 value={this.state.currentZoomValue} useGrouping={false}/>
							<span className="p-inputgroup-addon">%</span>
						</div>
						<div className="zoom-slider">
							<Slider value={this.state.currentZoomValue} max={400} min={10}
									disabled={!viewerActive || !hasZoom || fileLocked}
									onChange={
										(e) => this.setZoom(e.value as number)
									}/>
						</div>
					</div>
					<p className="menu-group-label">
						<Translate {...this.props} data="mobile.title" namespace="menu"/>
					</p>
				</div>
				<div className="menu-block desktop" data-help="global.menu.mouse" data-position="right">
					<div className="menu-group small">
						<MenuButton {...this.props} disabled={!viewerActive || !hasMouseModes || fileLocked}
									icon="icon icon-hand"
									className={
										viewerActive && viewerSettings?.activeViewer.mouseMode === MouseMode.MOVE &&
										hasMouseModes ? "active" : ""
									}
									label={Translate.value("mouse.move.label", {ns: "menu"})}
									tooltip={Translate.value("mouse.move.tooltip", {ns: "menu"})}
									onClick={async () => {
										let command: () => Promise<void> = async () => {
											let viewerSettings: DocumentSettings | undefined =
												this.getCurrentSettings(true);
											if (!FunctionHelper.exists(viewerSettings)) {
												return;
											}

											viewerSettings!.resetMouseMode();
											viewerSettings!.activeViewer.mouseMode = MouseMode.MOVE;
											documentManager.updateGlobalDocumentList();
										}

										if (DocumentSettings.checkActiveMouseFunction(this.props)) {
											DocumentSettings.confirmResetMouseFunction(this.props, command);
											return;
										}

										await command();
									}}/>
						<MenuButton {...this.props} disabled={!viewerActive || !hasMouseModes || fileLocked}
									icon="icon icon-pointer"
									className={
										viewerActive && viewerSettings?.activeViewer.mouseMode === MouseMode.TEXT &&
										hasMouseModes ? "active" : ""
									}
									label={Translate.value("mouse.select.label", {ns: "menu"})}
									tooltip={Translate.value("mouse.select.tooltip", {ns: "menu"})}
									onClick={async () => {
										let command: () => Promise<void> = async () => {
											let viewerSettings: DocumentSettings | undefined =
												this.getCurrentSettings(true);
											if (!FunctionHelper.exists(viewerSettings)) {
												return;
											}

											viewerSettings!.resetMouseMode();
											viewerSettings!.activeViewer.mouseMode = MouseMode.TEXT;
											documentManager.updateGlobalDocumentList();
										}

										if (DocumentSettings.checkActiveMouseFunction(this.props)) {
											DocumentSettings.confirmResetMouseFunction(this.props, command);
											return;
										}

										await command();
									}}/>
						<MenuButton {...this.props} disabled={!viewerActive || !hasMouseModes || fileLocked}
									icon="icon icon-zoom-area"
									className={
										viewerActive && viewerSettings?.activeViewer.mouseMode === MouseMode.ZOOM &&
										hasMouseModes ? "active" : ""
									}
									label={Translate.value("mouse.zoom.label", {ns: "menu"})}
									tooltip={Translate.value("mouse.zoom.tooltip", {ns: "menu"})}
									onClick={async () => {
										let command: () => Promise<void> = async () => {
											let viewerSettings: DocumentSettings | undefined =
												this.getCurrentSettings(true);
											if (!FunctionHelper.exists(viewerSettings)) {
												return;
											}

											viewerSettings!.resetMouseMode();
											viewerSettings!.activeViewer.mouseMode = MouseMode.ZOOM;
											documentManager.updateGlobalDocumentList();
										}

										if (DocumentSettings.checkActiveMouseFunction(this.props)) {
											DocumentSettings.confirmResetMouseFunction(this.props, command);
											return;
										}

										await command();
									}}/>
					</div>
					<p className="menu-group-label">
						<Translate {...this.props} data="mouse.title" namespace="menu"/>
					</p>
				</div>
				<div className="menu-separator desktop"/>
				<div className="menu-block desktop" data-help="global.menu.page" data-position="right">
					<div className="menu-group small">
						<MenuButton {...this.props} disabled={!viewerActive || !hasPageModes || fileLocked}
									icon="icon icon-page"
									className={
										viewerActive && viewerSettings?.activeViewer.pageMode === PageViewMode.SINGLE &&
										hasPageModes ? "active" : ""
									}
									label={Translate.value("page.single.label", {ns: "menu"})}
									tooltip={Translate.value("page.single.tooltip", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.pageMode = PageViewMode.SINGLE;
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props} disabled={!viewerActive || !hasPageModes || fileLocked}
									icon="icon icon-dual"
									className={
										viewerActive && viewerSettings?.activeViewer.pageMode === PageViewMode.DUAL &&
										hasPageModes ? "active" : ""
									}
									label={Translate.value("page.dual.label", {ns: "menu"})}
									tooltip={Translate.value("page.dual.tooltip", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.pageMode = PageViewMode.DUAL;
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props}
									className={
										viewerActive && viewerSettings?.activeViewer.continuous && hasPageModes ? "active" : ""
									}
									disabled={!viewerActive || !hasPageModes || fileLocked} icon="icon icon-scrolling"
									label={Translate.value("page.continuous.label", {ns: "menu"})}
									tooltip={Translate.value("page.continuous.tooltip", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.continuous = !viewerSettings?.activeViewer.continuous;
										documentManager.updateGlobalDocumentList();
									}}/>
					</div>
					<div className="menu-group small">
						<MenuButton {...this.props}
									className={viewerActive && viewerSettings?.activeViewer.pageCover && hasPageModes &&
									viewerSettings?.activeViewer.pageMode === PageViewMode.DUAL ? "active" : ""}
									disabled={
										!viewerActive || !hasPageModes || fileLocked ||
										viewerSettings?.activeViewer.pageMode !== PageViewMode.DUAL
									}
									label={Translate.value("page.cover.label", {ns: "menu"})}
									tooltip={Translate.value("page.cover.tooltip", {ns: "menu"})}
									icon="icon icon-page-cover"
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.pageCover = !viewerSettings!.activeViewer.pageCover;
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props}
									className={viewerActive && viewerSettings?.activeViewer.pagePadding && hasPageModes &&
									viewerSettings?.activeViewer.pageMode === PageViewMode.DUAL ? "active" : ""}
									disabled={
										!viewerActive || !hasPageModes || fileLocked ||
										viewerSettings?.activeViewer.pageMode !== PageViewMode.DUAL
									}
									label={Translate.value("page.padding.label", {ns: "menu"})}
									tooltip={Translate.value("page.padding.tooltip", {ns: "menu"})}
									icon="icon icon-page-padding"
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.pagePadding = !viewerSettings!.activeViewer.pagePadding;
										documentManager.updateGlobalDocumentList();
									}}/>
					</div>
					<div className="menu-function">
						<MenuButton {...this.props} icon="icon icon-first" className="page-button"
									disabled={!viewerActive || !hasPages || !hasPreviousPage || fileLocked}
									tooltip={Translate.value("page.first", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.firstPage();
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props} icon="icon icon-previous" className="page-button"
									disabled={!viewerActive || !hasPages || !hasPreviousPage || fileLocked}
									tooltip={Translate.value("page.previous", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.previousPage();
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props} icon="icon icon-next" className="page-button"
									disabled={!viewerActive || !hasPages || !hasNextPage || fileLocked}
									tooltip={Translate.value("page.next", {ns: "menu"})}
									onClick={async () => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.nextPage(pageCount);
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props} icon="icon icon-last" className="page-button"
									disabled={!viewerActive || !hasPages || !hasNextPage || fileLocked}
									tooltip={Translate.value("page.last", {ns: "menu"})}
									onClick={async () => {
										let viewerSettings: DocumentSettings | undefined =
											this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.lastPage(pageCount);
										documentManager.updateGlobalDocumentList();
									}}/>
						<div className="p-inputgroup page-input">
							<InputNumber disabled={!viewerActive || !hasPages || fileLocked} value={currentPage}
										 max={pageCount} min={1} useGrouping={false}
										 onValueChange={(event) => {
											 let value = FunctionHelper.applyValue(
												 event.value, 1
											 );
											 if (value <= 0) {
												 value = 1;
											 }

											 let viewerSettings: DocumentSettings | undefined =
												 this.getCurrentSettings(true);
											 if (!FunctionHelper.exists(viewerSettings)) {
												 return;
											 }

											 if (viewerSettings!.activeViewer.currentPage !== value) {
												 viewerSettings!.activeViewer.currentPage = value;
												 documentManager.updateGlobalDocumentList();
											 }
										 }}/>
							<span className="p-inputgroup-addon">/ {pageCount}</span>
						</div>
					</div>
					<p className="menu-group-label">
						<Translate {...this.props} data="page.title" namespace="menu"/>
					</p>
				</div>
				<div className="menu-separator desktop"/>
				<div className="menu-block desktop" data-help="global.menu.zoom" data-position="bottom">
					<div className="menu-group small">
						<MenuButton {...this.props}
									className={
										viewerActive && viewerSettings?.activeViewer.zoomMode === ZoomMode.PAGE ? "active" : ""
									}
									disabled={!viewerActive || !hasZoom || fileLocked} icon="icon icon-zoom-fit"
									label={Translate.value("zoom.fit.label", {ns: "menu"})}
									tooltip={Translate.value("zoom.fit.tooltip", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined = this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.zoomMode = ZoomMode.PAGE;
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props}
									className={
										viewerActive && viewerSettings?.activeViewer.zoomMode === ZoomMode.WIDTH ? "active" : ""
									}
									disabled={!viewerActive || !hasZoom || fileLocked} icon="icon icon-zoom-width"
									label={Translate.value("zoom.width.label", {ns: "menu"})}
									tooltip={Translate.value("zoom.width.tooltip", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined = this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.zoomMode = ZoomMode.WIDTH;
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props}
									className={
										viewerActive && viewerSettings?.activeViewer.zoomMode === ZoomMode.HEIGHT ? "active" : ""
									}
									disabled={!viewerActive || !hasZoom || fileLocked} icon="icon icon-zoom-height"
									label={Translate.value("zoom.height.label", {ns: "menu"})}
									tooltip={Translate.value("zoom.height.tooltip", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined = this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.zoomMode = ZoomMode.HEIGHT;
										documentManager.updateGlobalDocumentList();
									}}/>
					</div>
					<div className="menu-group small">
						<MenuButton {...this.props} icon="icon icon-zoom-original"
									disabled={!viewerActive || !hasZoom || fileLocked}
									className={
										viewerActive && viewerSettings?.activeViewer.zoomMode === ZoomMode.ORIGINAL ? "active" : ""
									}
									label={Translate.value("zoom.original.label", {ns: "menu"})}
									tooltip={Translate.value("zoom.original.tooltip", {ns: "menu"})}
									onClick={() => {
										let viewerSettings: DocumentSettings | undefined = this.getCurrentSettings(true);
										if (!FunctionHelper.exists(viewerSettings)) {
											return;
										}

										viewerSettings!.activeViewer.zoomMode = ZoomMode.ORIGINAL;
										documentManager.updateGlobalDocumentList();
									}}/>
						<MenuButton {...this.props} icon="icon icon-zoom-fullscreen"
									disabled={!viewerActive || !hasZoom || fileLocked || !document.fullscreenEnabled}
									label={Translate.value("zoom.fullscreen.label", {ns: "menu"})}
									tooltip={Translate.value("zoom.fullscreen.tooltip", {ns: "menu"})}
									onClick={async () => {
										let command: () => Promise<void> = async () => {
											let viewerSettings: DocumentSettings | undefined = this.getCurrentSettings(true);
											if (!FunctionHelper.exists(viewerSettings)) {
												return;
											}

											viewerSettings!.fullscreen = true;
											viewerSettings!.resetMouseMode();
											viewerSettings!.fullscreenSettings.mouseMode = MouseMode.MOVE;
											viewerSettings!.fullscreenSettings.continuous = false;
											viewerSettings!.fullscreenSettings.pageMode = PageViewMode.SINGLE;
											documentManager.updateGlobalDocumentList();
										}

										if (DocumentSettings.checkActiveMouseFunction(this.props)) {
											DocumentSettings.confirmResetMouseFunction(this.props, command);
											return;
										}

										await command();
									}}/>
					</div>
					<div className="menu-function">
						<div className="p-inputgroup zoom">
							<MenuButton {...this.props} icon="icon icon-angle-down"
										disabled={!viewerActive || !hasZoom || fileLocked}
										menuItems={
											[
												{label: "10 %", command: () => this.setZoom(10)},
												{label: "25 %", command: () => this.setZoom(25)},
												{label: "50 %", command: () => this.setZoom(50)},
												{label: "75 %", command: () => this.setZoom(75)},
												{label: "100 %", command: () => this.setZoom(100)},
												{label: "125 %", command: () => this.setZoom(125)},
												{label: "150 %", command: () => this.setZoom(150)},
												{label: "200 %", command: () => this.setZoom(200)},
												{label: "400 %", command: () => this.setZoom(400)},
											]
										}/>
							<InputNumber max={400} min={10} disabled={!viewerActive || !hasZoom || fileLocked}
										 onValueChange={(e) => this.setZoom(
											 FunctionHelper.applyValue(e.value, 100)
										 )}
										 value={this.state.currentZoomValue} useGrouping={false}/>
							<span className="p-inputgroup-addon">%</span>
						</div>
						<div className="zoom-slider">
							<Slider value={this.state.currentZoomValue} max={400} min={10}
									disabled={!viewerActive || !hasZoom || fileLocked}
									onChange={
										(e) => this.setZoom(e.value as number)
									}/>
						</div>
					</div>
					<p className="menu-group-label">
						<Translate {...this.props} data="zoom.title" namespace="menu"/>
					</p>
				</div>
				<div className="menu-separator"/>
			</>
		);
	}

	public renderMobileMenu(): ReactNode {
		let portalInfo: Information = this.props.context.info;

		let toggleIcon: Array<string> = ["icon"];
		if (this.state.activeMenu) {
			toggleIcon.push("icon-angle-up");
		} else {
			toggleIcon.push("icon-angle-down");
		}

		let logo: string = FunctionHelper.applyValue(
			portalInfo.userInterface?.resources?.logoFileName, UserInterfaceResources.getLogoFileNameDefault()
		);
		if (FunctionHelper.isEmpty(logo)) {
			logo = "logo" + portalConfiguration.cachingPath + ".png";
		}

		return (
			<div className="mobile-menu">
				<MenuButton {...this.props} icon="icon icon-menu"
							tooltip={Translate.value("mobile.label", {ns: "menu"})}
							menuClassName="mobile-menu-dropdown"
							menuItems={
								[
									{
										label: Translate.value("file.title", {ns: "menu"}),
										className: [
											"menu-mobile-file",
											this.state.activeTab === MenuTabs.FILE ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.FILE,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("convert.title", {ns: "menu"}),
										className: [
											"menu-mobile-convert",
											this.state.activeTab === MenuTabs.CONVERT ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.CONVERT,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("pages.title", {ns: "menu"}),
										className: [
											"menu-mobile-pages",
											this.state.activeTab === MenuTabs.PAGES ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.PAGES,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("watermark.title", {ns: "menu"}),
										className: [
											"menu-mobile-watermark",
											this.state.activeTab === MenuTabs.WATERMARK ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.WATERMARK,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("attachment.title", {ns: "menu"}),
										className: [
											"menu-mobile-attachment",
											this.state.activeTab === MenuTabs.ATTACHMENT ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.ATTACHMENT,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("signature.title", {ns: "menu"}),
										className: [
											"menu-mobile-signature",
											this.state.activeTab === MenuTabs.SIGNATURE ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.SIGNATURE,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("export.title", {ns: "menu"}),
										className: [
											"menu-mobile-export",
											this.state.activeTab === MenuTabs.EXPORT ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.EXPORT,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("form.title", {ns: "menu"}),
										className: [
											"menu-mobile-form",
											this.state.activeTab === MenuTabs.FORM ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.FORM,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("comment.title", {ns: "menu"}),
										className: [
											"menu-mobile-comment",
											this.state.activeTab === MenuTabs.COMMENT ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.COMMENT,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("barcode.title", {ns: "menu"}),
										className: [
											"menu-mobile-barcode",
											this.state.activeTab === MenuTabs.BARCODE ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.BARCODE,
												activeMenu: true
											});
										}
									},
									{
										label: Translate.value("redact.title", {ns: "menu"}),
										className: [
											"menu-mobile-redact",
											this.state.activeTab === MenuTabs.REDACT ? "active" : ""
										].join(" "),
										command: () => {
											this.setState({
												activeTab: MenuTabs.REDACT,
												activeMenu: true
											});
										}
									}
								]
							}/>
				<MenuButton {...this.props} tooltip={Translate.value("mobile.toggle", {ns: "menu"})}
							className="toggle-mobile-menu" icon={toggleIcon.join(" ")}
							onClick={() => {
								this.setState({
									activeMenu: !this.state.activeMenu
								});
							}}/>
				<div className="logo tooltip" data-pr-tooltip={
					this.props.context.info.serverVersion!.replace(/ *\([^)]*\) */g, "").trim()
				}>
					<img src={portalConfiguration.baseUrl + "image/res/" + logo}
						 onClick={() => window.location.reload()}
						 alt="webPDF Logo"/>
				</div>
			</div>
		);
	}

	private renderToolbar(): ReactNode {
		let portalInfo: Information = this.props.context.info;
		let provider: AuthProvider | undefined = this.getProvider();
		let portalDocuments: Array<PortalDocumentInterface> = this.props.portalDocuments.get();
		let userSettings: UserSettings = UserSettings.fromJson(this.props.userSettings.get());
		let certificates: UserCertificates | undefined = UserCertificates.fromJson(this.props.userCertificates.get());

		let user: UserCredentials | undefined = this.props.context.user;
		let diskSpaceLimit: number = FunctionHelper.applyValue(
			user?.userLimits?.diskSpaceLimit, Limits.getDiskSpaceLimitDefault()
		);
		let maxFiles: number = FunctionHelper.applyValue(user?.userLimits?.maxFiles, Limits.getMaxFilesDefault());
		let uploadedFiles: number = portalDocuments.length;
		let uploadedFileSize: number = 0;
		for (let portalDocument of portalDocuments) {
			uploadedFileSize += portalDocument.size;
		}

		let showCertificateHint: boolean = false;
		if (!userSettings.disableCertificateHints) {
			for (let keystore of FunctionHelper.applyValue(
				certificates?.keyStores, UserCertificates.getKeyStoresDefault()
			)) {
				if (!keystore.isKeyStoreAccessible) {
					showCertificateHint = true;
					break;
				}
			}
		}

		let userName: Array<MenuItem> = [];
		if (!FunctionHelper.isEmpty(user?.userName)) {
			userName.push({
				className: "legend",
				label: user!.userName
			});
		}

		let generalMenuItems: Array<MenuItem> = [];

		if (FunctionHelper.applyValue(user?.isAdmin, UserCredentials.getIsAdminDefault())) {
			generalMenuItems.push({
				icon: "icon icon-admin",
				label: Translate.value("toolbar.admin", {ns: "menu"}),
				command: async () => {
					let command: () => Promise<void> = async () => {
						window.location.href = portalConfiguration.portalUrl.toString() + Admin.route;
					}

					if (DocumentSettings.checkActiveMouseFunction(this.props)) {
						DocumentSettings.confirmResetMouseFunction(this.props, command);
						return;
					}

					await command();
				}
			});
		}

		if (FunctionHelper.applyValue(portalInfo.functionsStatus?.showHelp, PortalFunctions.getShowHelpDefault())) {
			generalMenuItems.push({
				className: "global-help",
				icon: "icon icon-help circle",
				label: Translate.value("toolbar.help", {ns: "menu"}),
				command: (e) => {
					this.props.context.getPage().setState({
						showHelpScreen: true
					});
				}
			});
		}

		return (
			<>
				<div className="toolbar mobile" data-help="global.menu.general" data-position="left">
					{FunctionHelper.exists(user) ?
						<MenuButton {...this.props} tooltipOptions={{position: 'left'}}
									tooltip={Translate.value("toolbar.user", {ns: "menu"})}
									className="usermanagement-button"
									onClick={(e) => {
										if (e.ctrlKey && e.altKey) {
											e.stopPropagation();
											e.preventDefault();

											this.props.context.getPage().setState({
												showDebugDialog: true
											});
											return;
										}
									}}
									menuItems={
										[
											...userName,
											{
												label: Translate.value(
													"toolbar.settings.certificate.label", {ns: "menu"}
												),
												icon: "icon icon-certificate",
												disabled: this.props.context.session.getCertificates()?.keyStores.length === 0,
												command: async () => {
													let command: () => Promise<void> = async () => {
														this.props.context.getPage().setState({
															showCertificateSettingsDialog: true
														});
													}

													if (DocumentSettings.checkActiveMouseFunction(this.props)) {
														DocumentSettings.confirmResetMouseFunction(this.props, command);
														return;
													}

													await command();
												}
											},
											{
												template: (): React.ReactNode => {
													return (
														<div className="p-col-12" hidden={
															!portalInfo.userInterface?.limits?.displayMaxFiles ||
															maxFiles === 0
														}>
															<ProgressBar unit=""
																		 label={Translate.value(
																			 "toolbar.limits.documents",
																			 {
																				 ns: "menu",
																				 value: uploadedFiles,
																				 max: maxFiles
																			 }
																		 )}
																		 bars={[
																			 {value: (uploadedFiles / maxFiles) * 100}
																		 ]}/>
														</div>
													);
												}
											},
											{
												template: (): React.ReactNode => {
													return (
														<div className="p-col-12"
															 hidden={
																 !portalInfo.userInterface?.limits?.displayDiskSpace ||
																 diskSpaceLimit === 0
															 }>
															<ProgressBar unit=""
																		 label={
																			 Translate.value(
																				 "toolbar.limits.workspace",
																				 {
																					 ns: "menu",
																					 value: FileHelper.formatFileSize(uploadedFileSize),
																					 max: FileHelper.formatFileSize(diskSpaceLimit * 1024 * 1024)
																				 }
																			 )}
																		 bars={[
																			 {
																				 value: (
																					 FileHelper.formatFileSizeAs(FileSizeUnit.MEGABYTES, uploadedFileSize) /
																					 diskSpaceLimit
																				 ) * 100
																			 }
																		 ]}/>
														</div>
													);
												}
											},
											{
												separator: true
											},
											...generalMenuItems,
											{
												icon: "icon icon-flag",
												label: Translate.value("toolbar.language.title", {ns: "menu"}),
												items: [
													{
														label: Translate.value(
															"toolbar.language.english", {ns: "menu"}
														),
														icon: "icon icon-flag-en",
														command: () => changeLanguage(Language.ENGLISH)
													},
													{
														label: Translate.value(
															"toolbar.language.german", {ns: "menu"}
														),
														icon: "icon icon-flag-de",
														command: () => changeLanguage(Language.GERMAN)
													}
												]
											},
											{
												separator: true
											},
											{
												label: Translate.value(
													"toolbar.logout", {ns: "menu"}
												),
												icon: "icon icon-logout",
												className: "global-user-logout",
												command: async () => {
													let command: () => Promise<void> = async () => {
														await this.handleLogout.bind(this)()
													}

													if (DocumentSettings.checkActiveMouseFunction(this.props)) {
														DocumentSettings.confirmResetMouseFunction(this.props, command);
														return;
													}

													await command();
												}
											}
										]
									}>
							{this.renderUserIcon(provider)}
							{showCertificateHint &&
								<div className="badge">
									<Icon icon={"icon-warning"} position={"left"} tooltip={
										<Translate {...this.props}
												   data="toolbar.settings.certificate.locked"
												   namespace={"menu"}/>
									}/>
								</div>
							}
						</MenuButton> :
						<MenuButton {...this.props} icon="icon icon-user"
									onClick={async () => {
										let command: () => Promise<void> = async () => {
											await this.handleLogin.bind(this)();
										}

										if (DocumentSettings.checkActiveMouseFunction(this.props)) {
											DocumentSettings.confirmResetMouseFunction(this.props, command);
											return;
										}

										await command();
									}} tooltipOptions={{position: 'left'}}
									tooltip={Translate.value("toolbar.login", {ns: "menu"})}/>
					}
				</div>
				<div className="toolbar" data-help="global.menu.general" data-position="left">
					{FunctionHelper.exists(user) ?
						<MenuButton {...this.props} tooltipOptions={{position: 'left'}} className="global-user-button"
									tooltip={Translate.value("toolbar.user", {ns: "menu"})}
									menuItems={
										[
											{
												label: Translate.value(
													"toolbar.settings.certificate.label", {ns: "menu"}
												),
												icon: "icon icon-certificate",
												disabled: this.props.context.session.getCertificates()?.keyStores.length === 0,
												command: async () => {
													let command: () => Promise<void> = async () => {
														this.props.context.getPage().setState({
															showCertificateSettingsDialog: true
														});
													}

													if (DocumentSettings.checkActiveMouseFunction(this.props)) {
														DocumentSettings.confirmResetMouseFunction(this.props, command);
														return;
													}

													await command();
												}
											},
											{
												template: (): React.ReactNode => {
													return (
														<div className="p-col-12" hidden={
															!portalInfo.userInterface?.limits?.displayMaxFiles ||
															maxFiles === 0
														}>
															<ProgressBar unit=""
																		 label={Translate.value(
																			 "toolbar.limits.documents",
																			 {
																				 ns: "menu",
																				 value: uploadedFiles,
																				 max: maxFiles
																			 }
																		 )}
																		 bars={[
																			 {value: (uploadedFiles / maxFiles) * 100}
																		 ]}/>
														</div>
													);
												}
											},
											{
												template: (): React.ReactNode => {
													return (
														<div className="p-col-12"
															 hidden={
																 !portalInfo.userInterface?.limits?.displayDiskSpace ||
																 diskSpaceLimit === 0
															 }>
															<ProgressBar unit=""
																		 label={
																			 Translate.value(
																				 "toolbar.limits.workspace",
																				 {
																					 ns: "menu",
																					 value: FileHelper.formatFileSize(uploadedFileSize),
																					 max: FileHelper.formatFileSize(diskSpaceLimit * 1024 * 1024)
																				 }
																			 )}
																		 bars={[
																			 {
																				 value: (
																					 FileHelper.formatFileSizeAs(FileSizeUnit.MEGABYTES, uploadedFileSize) /
																					 diskSpaceLimit
																				 ) * 100
																			 }
																		 ]}/>
														</div>
													);
												}
											},
											{
												separator: true
											},
											{
												label: Translate.value(
													"toolbar.logout", {ns: "menu"}
												),
												icon: "icon icon-logout",
												className: "global-user-logout",
												command: async () => {
													let command: () => Promise<void> = async () => {
														await this.handleLogout.bind(this)()
													}

													if (DocumentSettings.checkActiveMouseFunction(this.props)) {
														DocumentSettings.confirmResetMouseFunction(this.props, command);
														return;
													}

													await command();
												}
											}
										]
									}>
							{this.renderUserIcon(provider)}
							{!FunctionHelper.isEmpty(user?.userName) &&
								<span className="p-button-label p-c">{user!.userName}</span>
							}
							{showCertificateHint &&
								<div className="badge">
									<Icon icon={"icon-warning"} position={"left"} tooltip={
										<Translate {...this.props}
												   data="toolbar.settings.certificate.locked"
												   namespace={"menu"}/>
									}/>
								</div>
							}
						</MenuButton> :
						<MenuButton {...this.props} icon="icon icon-user" className="global-user-button"
									onClick={async () => {
										let command: () => Promise<void> = async () => {
											await this.handleLogin.bind(this)();
										}

										if (DocumentSettings.checkActiveMouseFunction(this.props)) {
											DocumentSettings.confirmResetMouseFunction(this.props, command);
											return;
										}

										await command();
									}} tooltipOptions={{position: 'left'}}
									tooltip={Translate.value("toolbar.login", {ns: "menu"})}/>
					}
					{FunctionHelper.applyValue(user?.isAdmin, UserCredentials.getIsAdminDefault()) &&
						<MenuButton {...this.props} icon="icon icon-admin"
									tooltip={Translate.value("toolbar.admin", {ns: "menu"})}
									tooltipOptions={{position: 'left'}}
									onClick={async () => {
										let command: () => Promise<void> = async () => {
											window.location.href = portalConfiguration.portalUrl.toString() + Admin.route;
										}

										if (DocumentSettings.checkActiveMouseFunction(this.props)) {
											DocumentSettings.confirmResetMouseFunction(this.props, command);
											return;
										}

										await command();
									}}/>
					}
					{
						FunctionHelper.applyValue(
							portalInfo.functionsStatus?.showHelp, PortalFunctions.getShowHelpDefault()
						) &&
						<MenuButton {...this.props} icon="icon icon-help circle" className="global-help-button"
									onClick={(e) => {
										if (e.ctrlKey && e.altKey) {
											this.props.context.getPage().setState({
												showDebugDialog: true
											});
											return;
										}

										this.props.context.getPage().setState({
											showHelpScreen: true
										});
									}}
									tooltipOptions={{position: 'left'}}
									tooltip={Translate.value("toolbar.help", {ns: "menu"})}/>
					}
					<MenuButton {...this.props} icon="icon icon-flag" tooltipOptions={{position: 'left'}}
								tooltip={Translate.value("toolbar.language.title", {ns: "menu"})}
								className="global-language-button"
								menuItems={
									[
										{
											label: Translate.value(
												"toolbar.language.english", {ns: "menu"}
											),
											className: "global-language-en",
											icon: "icon icon-flag-en",
											command: () => changeLanguage(Language.ENGLISH)
										},
										{
											label: Translate.value(
												"toolbar.language.german", {ns: "menu"}
											),
											className: "global-language-de",
											icon: "icon icon-flag-de",
											command: () => changeLanguage(Language.GERMAN)
										}
									]
								}/>
					<MenuButton {...this.props} tooltipOptions={{position: 'left'}}
								className={(this.props.showLog ? "active" : "")}
								icon="icon icon-bell"
								onClick={
									() => this.props.context.getPage().setState({
										showLog: !this.props.showLog
									})
								}
								tooltip={Translate.value("toolbar.log", {ns: "menu"})}/>
				</div>
			</>
		)
	}

	private renderTabs(): ReactNode {
		let portalInfo: Information = this.props.context.info;

		return (
			<ul>
				<li className={this.state.activeTab === MenuTabs.FILE ? "active" : ""}>
					<MenuButton {...this.props} className="menu-bar-file" onClick={() => {
						this.setState({
							activeTab: MenuTabs.FILE
						});
					}}>
						<Translate {...this.props} data="file.title" namespace="menu"/>
					</MenuButton>
				</li>
				{
					(
						!this.props.documentChecks ||
						ConvertDialogDefinition.isEnabled(portalInfo) ||
						PdfaDialogDefinition.isEnabled(portalInfo) ||
						OcrDialogDefinition.isEnabled(portalInfo) ||
						PortfolioCreateDialogDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.CONVERT ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-convert" onClick={() => {
							this.setState({
								activeTab: MenuTabs.CONVERT
							});
						}}>
							<Translate {...this.props} data="convert.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{
					(
						!this.props.documentChecks ||
						RotateDialogDefinition.isEnabled(portalInfo) ||
						DeletePageDialogDefinition.isEnabled(portalInfo) ||
						SplitDialogDefinition.isEnabled(portalInfo) ||
						BackgroundDialogDefinition.isEnabled(portalInfo) ||
						HeaderFooterDialogDefinition.isEnabled(portalInfo) ||
						BoxesDialogDefinition.isEnabled(portalInfo) ||
						TransitionDialogDefinition.isEnabled(portalInfo) ||
						PageAddDialogDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.PAGES ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-pages" onClick={() => {
							this.setState({
								activeTab: MenuTabs.PAGES
							});
						}}>
							<Translate {...this.props} data="pages.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{(!this.props.documentChecks || WatermarkDialogDefinition.isEnabled(portalInfo)) &&
					<li className={this.state.activeTab === MenuTabs.WATERMARK ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-watermark" onClick={() => {
							this.setState({
								activeTab: MenuTabs.WATERMARK
							});
						}}>
							<Translate {...this.props} data="watermark.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{
					(
						!this.props.documentChecks ||
						GlobalAttachmentDialogDefinition.isEnabled(portalInfo) ||
						AttachmentDialogDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.ATTACHMENT ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-attachment" onClick={() => {
							this.setState({
								activeTab: MenuTabs.ATTACHMENT
							});
						}}>
							<Translate {...this.props} data="attachment.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{(!this.props.documentChecks || SignatureDialogDefinition.isEnabled(portalInfo)) &&
					<li className={this.state.activeTab === MenuTabs.SIGNATURE ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-signature" onClick={() => {
							this.setState({
								activeTab: MenuTabs.SIGNATURE
							});
						}}>
							<Translate {...this.props} data="signature.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{
					(
						!this.props.documentChecks ||
						ContentExtractionDialogDefinition.isEnabled(portalInfo) ||
						ImageExtractionDialogDefinition.isEnabled(portalInfo) ||
						InfoExtractionDialogDefinition.isEnabled(portalInfo) ||
						PageExtractionDialogDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.EXPORT ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-export" onClick={() => {
							this.setState({
								activeTab: MenuTabs.EXPORT
							});
						}}>
							<Translate {...this.props} data="export.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{
					(
						!this.props.documentChecks ||
						FormsImportDialogDefinition.isEnabled(portalInfo) ||
						FormsExtractionDialogDefinition.isEnabled(portalInfo) ||
						FormsFlattenDialogDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.FORM ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-form" onClick={() => {
							this.setState({
								activeTab: MenuTabs.FORM
							});
						}}>
							<Translate {...this.props} data="form.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{
					(
						!this.props.documentChecks ||
						AnnotationNoteFunctionDefinition.isEnabled(portalInfo) ||
						AnnotationMarkFunctionDefinition.isEnabled(portalInfo) ||
						AnnotationUnderlineFunctionDefinition.isEnabled(portalInfo) ||
						AnnotationStrikeFunctionDefinition.isEnabled(portalInfo) ||
						AnnotationSquigglyFunctionDefinition.isEnabled(portalInfo) ||
						AnnotationLineFunctionDefinition.isEnabled(portalInfo) ||
						AnnotationSquigglyFunctionDefinition.isEnabled(portalInfo) ||
						AnnotationCircleFunctionDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.COMMENT ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-comment" onClick={() => {
							this.setState({
								activeTab: MenuTabs.COMMENT
							});
						}}>
							<Translate {...this.props} data="comment.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{
					(
						!this.props.documentChecks ||
						BarcodeCreateAreaDialogDefinition.isEnabled(portalInfo) ||
						BarcodeDetectDialogDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.BARCODE ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-barcode" onClick={() => {
							this.setState({
								activeTab: MenuTabs.BARCODE
							});
						}}>
							<Translate {...this.props} data="barcode.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
				{
					(
						!this.props.documentChecks ||
						RedactDialogDefinition.isEnabled(portalInfo) ||
						RedactTextFunctionDefinition.isEnabled(portalInfo) ||
						RedactAreaFunctionDefinition.isEnabled(portalInfo) ||
						RedactPageDialogDefinition.isEnabled(portalInfo)
					) &&
					<li className={this.state.activeTab === MenuTabs.REDACT ? "active" : ""}>
						<MenuButton {...this.props} className="menu-bar-redact" onClick={() => {
							this.setState({
								activeTab: MenuTabs.REDACT
							});
						}}>
							<Translate {...this.props} data="redact.title" namespace="menu"/>
						</MenuButton>
					</li>
				}
			</ul>
		);
	}

	private renderFileTab(): ReactNode {
		if (this.state.activeTab !== MenuTabs.FILE) {
			return null;
		}

		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let selection: Array<PortalDocument> = documentManager.getSelection();
		let portalInfo: Information = this.props.context.info;

		let selectionLocked: boolean = false;
		for (let selectedDocument of selection) {
			if (selectedDocument.isLocked()) {
				selectionLocked = true;
				break;
			}
		}

		return (
			<div className="tab-panel">
				{this.renderDocumentSettings()}
				<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.document"
					 data-position="bottom">
					<div className="menu-group">
						<MenuButton {...this.props} splitButton={true} icon="icon icon-download multiple"
									disabled={selection.length === 0 || selectionLocked}
									label={Translate.value(
										"file.download.label", {ns: "menu"}
									)}
									onClick={() => this.downloadDocuments()}
									menuItems={[
										{
											label: Translate.value(
												"file.download.single", {ns: "menu"}
											),
											command: () => this.downloadDocuments("single")
										},
										{
											label: Translate.value(
												"file.download.zip", {ns: "menu"}
											),
											command: () => this.downloadDocuments("zip")
										}
									]}/>
						{(!this.props.documentChecks || DeleteDialogDefinition.isEnabled(portalInfo)) &&
							<MenuButton {...this.props}
										disabled={this.props.documentChecks && !DeleteDialogDefinition.isActive(
											selection, portalInfo, this.props.signatureEditProfile
										)}
										label={Translate.value("file.delete", {ns: "menu"})}
										icon="icon icon-delete multiple"
										onClick={async () => {
											let command: () => Promise<void> = async () => {
												let selection: Array<PortalDocument> =
													documentManager.getSelection();
												let documentIds: Array<string> = [];

												for (let portalDocument of selection) {
													documentIds.push(portalDocument.getSourceDocumentId()!);
												}

												let parameter: Parameter<DeleteDocumentType> =
													new Parameter<DeleteDocumentType>(
														DeleteDocumentType.fromJson({
															documentIds: documentIds
														} as DeleteDocumentType)
													);

												this.props.context.getPage().setState({
													showDeleteDialog: true,
													deleteParameter: parameter
												});
											}

											if (DocumentSettings.checkActiveMouseFunction(this.props)) {
												DocumentSettings.confirmResetMouseFunction(this.props, command);
												return;
											}

											await command();
										}}/>
						}
						{(!this.props.documentChecks || RenameDialogDefinition.isEnabled(portalInfo)) &&
							<MenuButton {...this.props} icon="icon icon-rename"
										disabled={this.props.documentChecks && !RenameDialogDefinition.isActive(
											selection, portalInfo, this.props.signatureEditProfile
										)}
										label={Translate.value("file.rename", {ns: "menu"})}
										onClick={async () => {
											let command: () => Promise<void> = async () => {
												this.props.context.getPage().setState({
													showRenameDialog: true,
													renameParameter: undefined
												});
											}

											if (DocumentSettings.checkActiveMouseFunction(this.props)) {
												DocumentSettings.confirmResetMouseFunction(this.props, command);
												return;
											}

											await command();
										}}/>
						}
					</div>
					<div className="menu-group">
						{(!this.props.documentChecks || PrintDialogDefinition.isEnabled(portalInfo)) &&
							<MenuButton {...this.props} icon="icon icon-print" className="menu-bar-file-print"
										disabled={this.props.documentChecks && !PrintDialogDefinition.isActive(
											selection, portalInfo, this.props.signatureEditProfile
										)}
										label={Translate.value("file.print", {ns: "menu"})}
										onClick={async () => {
											let command: () => Promise<void> = async () => {
												this.props.context.getPage().setState({
													showPrintDialog: true,
													printParameter: undefined
												});
											}

											if (DocumentSettings.checkActiveMouseFunction(this.props)) {
												DocumentSettings.confirmResetMouseFunction(this.props, command);
												return;
											}

											await command();
										}}/>
						}
						{(!this.props.documentChecks || SanitizeDialogDefinition.isEnabled(portalInfo)) &&
							<MenuButton {...this.props} icon="icon icon-redact-sanitize"
										className="menu-bar-file-sanitize"
										disabled={this.props.documentChecks && !SanitizeDialogDefinition.isActive(
											selection, portalInfo, this.props.signatureEditProfile
										)}
										onClick={async () => {
											let command: () => Promise<void> = async () => {
												this.props.context.getPage().setState({
													showSanitizeDialog: true,
													sanitizeParameter: undefined
												});
											}

											if (DocumentSettings.checkActiveMouseFunction(this.props)) {
												DocumentSettings.confirmResetMouseFunction(this.props, command);
												return;
											}

											await command();
										}}
										label={Translate.value(
											"file.sanitize", {ns: "menu"}
										)}/>
						}
						{(!this.props.documentChecks || CompressionDialogDefinition.isEnabled(portalInfo)) &&
							<MenuButton {...this.props} icon="icon icon-compress" className="menu-bar-file-compress"
										disabled={this.props.documentChecks && !CompressionDialogDefinition.isActive(
											selection, portalInfo, this.props.signatureEditProfile
										)}
										onClick={async () => {
											let command: () => Promise<void> = async () => {
												this.props.context.getPage().setState({
													showCompressionDialog: true,
													compressionParameter: undefined
												});
											}

											if (DocumentSettings.checkActiveMouseFunction(this.props)) {
												DocumentSettings.confirmResetMouseFunction(this.props, command);
												return;
											}

											await command();
										}}
										label={Translate.value(
											"file.compression", {ns: "menu"}
										)}/>
						}
					</div>
					<p className="menu-group-label">
						<Translate {...this.props} data="file.title" namespace="menu"/>
					</p>
				</div>
			</div>
		);
	}

	/**
	 * render menu label as react node
	 */
	private renderLabel(): ReactNode {
		let documentSettings: DocumentSettings | undefined = this.getCurrentSettings();

		let classList: Array<string> = ["tab-label"];
		let label: string = "";

		switch (documentSettings?.activeViewer.mouseFunction) {
			case MouseFunction.BARCODE_CREATE:
			case MouseFunction.BARCODE_CREATE_SWISS_BILL:
			case MouseFunction.BARCODE_CREATE_SWISS_CODE:
			case MouseFunction.BARCODE_CREATE_SWISS_BILL_WITH_SPACE:
			case MouseFunction.BARCODE_DETECT:
				label = Translate.value("barcode.title", {ns: "menu"});
				classList.push("active");
				break;
			case MouseFunction.REDACT_TEXT:
			case MouseFunction.REDACT_AREA:
				label = Translate.value("redact.title", {ns: "menu"});
				classList.push("active");
				break;
			case MouseFunction.NOTE:
			case MouseFunction.MARK:
			case MouseFunction.UNDERLINE:
			case MouseFunction.STRIKE:
			case MouseFunction.SQUIGGLY:
			case MouseFunction.LINE:
			case MouseFunction.SQUARE:
			case MouseFunction.CIRCLE:
			case MouseFunction.STAMP_APPROVED:
			case MouseFunction.STAMP_EXPERIMENTAL:
			case MouseFunction.STAMP_NOT_APPROVED:
			case MouseFunction.STAMP_AS_IS:
			case MouseFunction.STAMP_EXPIRED:
			case MouseFunction.STAMP_NOT_FOR_PUBLIC_RELEASE:
			case MouseFunction.STAMP_CONFIDENTIAL:
			case MouseFunction.STAMP_FINAL:
			case MouseFunction.STAMP_SOLD:
			case MouseFunction.STAMP_DEPARTMENTAL:
			case MouseFunction.STAMP_FOR_COMMENT:
			case MouseFunction.STAMP_TOP_SECRET:
			case MouseFunction.STAMP_DRAFT:
			case MouseFunction.STAMP_FOR_PUBLIC_RELEASE:
			case MouseFunction.STAMP_CUSTOM:
				label = Translate.value("comment.title", {ns: "menu"});
				classList.push("active");
				break;
			case MouseFunction.FORMS_EDIT:
				label = Translate.value("form.title", {ns: "menu"});
				classList.push("active");
				break;
			case MouseFunction.WATERMARK:
				label = Translate.value("watermark.title", {ns: "menu"});
				classList.push("active");
				break;
			case MouseFunction.ATTACHMENT:
				label = Translate.value("attachment.title", {ns: "menu"});
				classList.push("active");
				break;
			case MouseFunction.SIGNATURE:
				label = Translate.value("signature.title", {ns: "menu"});
				classList.push("active");
				break;
		}

		return (
			<div className={classList.join(" ")}>
				<p>{label}</p>
			</div>
		);
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let documentManager: PortalDocumentManager = this.props.context.documentManager;
		let selection: Array<PortalDocument> = documentManager.getSelection();
		let documentSettings: DocumentSettings | undefined = this.getCurrentSettings();
		let portalInfo: Information = this.props.context.info;

		let panelClasses: Array<string> = ["tab-panels"];
		if (this.state.activeMenu) {
			panelClasses.push("in");
		}

		return (
			<>
				<div className="menu-bar">
					<div className="tabs">
						{this.renderMobileMenu()}
						{this.renderTabs()}
						{this.renderToolbar()}
					</div>
					<div className={panelClasses.join(" ")} ref={this.resizeRoot}>
						{this.renderFileTab()}
						{this.state.activeTab === MenuTabs.CONVERT &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.convert"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || ConvertDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															!ConvertDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-convert"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showConvertDialog: true,
																	convertParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value("convert.pdf", {ns: "menu"})}/>
										}
										{(!this.props.documentChecks || PdfaDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															!PdfaDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-archive"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showPdfaDialog: true,
																	pdfaParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"convert.archive", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || OcrDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															!OcrDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-ocr"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showOcrDialog: true,
																	ocrParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"convert.ocr", {ns: "menu"}
														)}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || PortfolioCreateDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															!PortfolioCreateDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-portfolio"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showPortfolioCreateDialog: true,
																	portfolioCreateParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"convert.portfolio", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="convert.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.PAGES &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.pages"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || RotateDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} splitButton={true}
														className="menu-bar-pages-rotate"
														label={Translate.value(
															"pages.rotate.title", {ns: "menu"}
														)}
														disabled={
															this.props.documentChecks &&
															!RotateDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-rotate-90"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showRotateDialog: true,
																	rotateParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														menuItems={[
															{
																label: Translate.value(
																	"pages.rotate.cw", {ns: "menu"}
																),
																icon: 'icon icon-rotate-90',
																className: "menu-bar-pages-rotate-90",
																command: async () => {
																	let command: () => Promise<void> = async () => {
																		let rotateParameter:
																			Parameter<ToolboxRotateRotate> =
																			DialogDefault.getParameter(
																				PortalDialogType.ROTATE, selection
																			);
																		rotateParameter.data.degrees = 90;

																		this.props.context.getPage().setState({
																			showRotateDialog: true,
																			rotateParameter: rotateParameter
																		});
																	}

																	if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																		DocumentSettings.confirmResetMouseFunction(this.props, command);
																		return;
																	}

																	await command();
																}
															},
															{
																label: Translate.value(
																	"pages.rotate.turn", {ns: "menu"}
																),
																icon: 'icon icon-rotate-180',
																className: "menu-bar-pages-rotate-180",
																command: async () => {
																	let command: () => Promise<void> = async () => {
																		let rotateParameter:
																			Parameter<ToolboxRotateRotate> =
																			DialogDefault.getParameter(
																				PortalDialogType.ROTATE, selection
																			);
																		rotateParameter.data.degrees = 180;

																		this.props.context.getPage().setState({
																			showRotateDialog: true,
																			rotateParameter: rotateParameter
																		});
																	}

																	if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																		DocumentSettings.confirmResetMouseFunction(this.props, command);
																		return;
																	}

																	await command();
																}
															},
															{
																label: Translate.value(
																	"pages.rotate.ccw", {ns: "menu"}
																),
																icon: 'icon icon-rotate-270',
																className: "menu-bar-pages-rotate-270",
																command: async () => {
																	let command: () => Promise<void> = async () => {
																		let rotateParameter:
																			Parameter<ToolboxRotateRotate> =
																			DialogDefault.getParameter(
																				PortalDialogType.ROTATE, selection
																			);
																		rotateParameter.data.degrees = 270;

																		this.props.context.getPage().setState({
																			showRotateDialog: true,
																			rotateParameter: rotateParameter
																		});
																	}

																	if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																		DocumentSettings.confirmResetMouseFunction(this.props, command);
																		return;
																	}

																	await command();
																}
															}
														]}/>
										}
										{(!this.props.documentChecks || OrientationDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-pages-orientation"
														disabled={
															this.props.documentChecks &&
															!OrientationDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-orientation"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showOrientationDialog: true,
																	orientationParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.orientation", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || DeletePageDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-pages-delete"
														disabled={
															this.props.documentChecks &&
															!DeletePageDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-delete-page"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showDeletePageDialog: true,
																	deletePageParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.delete", {ns: "menu"}
														)}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || SplitDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-pages-split"
														disabled={
															this.props.documentChecks &&
															!SplitDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-split"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showSplitDialog: true,
																	splitParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.split", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || BackgroundDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className={"menu-bar-pages-background"}
														disabled={
															this.props.documentChecks &&
															!BackgroundDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-background"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showBackgroundDialog: true,
																	backgroundParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.background", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || HeaderFooterDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-pages-header-footer"
														disabled={
															this.props.documentChecks &&
															!HeaderFooterDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-header-footer"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showHeaderFooterDialog: true,
																	headerFooterParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.headerFooter", {ns: "menu"}
														)}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || BoxesDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className={"menu-bar-pages-boxes"}
														disabled={
															this.props.documentChecks &&
															!BoxesDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-boxes"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showBoxesDialog: true,
																	boxesParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.boxes", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || TransitionDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-pages-transition"
														disabled={
															this.props.documentChecks &&
															!TransitionDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-transition"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showTransitionDialog: true,
																	transitionParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.transition", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || PageAddDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-pages-add"
														icon="icon icon-add-pages"
														disabled={
															this.props.documentChecks &&
															!PageAddDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showAddPageDialog: true,
																	addPageParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.add", {ns: "menu"}
														)}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || ScaleDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-pages-scale"
														icon="icon icon-scale"
														disabled={
															this.props.documentChecks &&
															!ScaleDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showScaleDialog: true,
																	scaleParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"pages.scale", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="pages.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.WATERMARK &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.watermark"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || WatermarkDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-watermark"
														className={"menu-bar-watermark-watermark"}
														disabled={
															this.props.documentChecks &&
															!WatermarkDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																let parameter: Parameter<PortalToolboxWatermarkWatermark> =
																	DialogDefault.getParameter(
																		PortalDialogType.WATERMARK, selection
																	);

																parameter.data.pages = documentSettings!.pageSelection.toString(
																	this.state.numberOfPages, documentSettings!.activeViewer.currentPage
																);

																this.props.context.getPage().setState({
																	watermarkParameter: parameter,
																	showWatermarkDialog: true
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"watermark.add", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || WatermarkDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-watermark-area"
														disabled={
															this.props.documentChecks &&
															(
																!WatermarkDialogDefinition.isActive(
																	selection, portalInfo, this.props.signatureEditProfile
																) || this.props.contentMode !== ContentMode.VIEWER
															)
														}
														className={
															documentSettings?.activeViewer.mouseFunction === MouseFunction.WATERMARK &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																this.setMouseMode(
																	documentSettings!,
																	MouseMode.RECTANGLE,
																	MouseFunction.WATERMARK
																);

																documentManager.updateGlobalDocumentList();
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"watermark.area", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="watermark.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.ATTACHMENT &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer}
									 data-help="global.menu.attachment" data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || GlobalAttachmentDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-attachment"
														className="menu-bar-attachment-attachment"
														disabled={
															this.props.documentChecks &&
															!GlobalAttachmentDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showGlobalAttachmentDialog: true,
																	globalAttachmentParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"attachment.add", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || AttachmentDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-attachment-area"
														disabled={
															this.props.documentChecks &&
															(
																!AttachmentDialogDefinition.isActive(
																	selection, portalInfo, this.props.signatureEditProfile
																) || this.props.contentMode !== ContentMode.VIEWER
															)
														}
														className={
															documentSettings?.activeViewer.mouseFunction === MouseFunction.ATTACHMENT &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																this.setMouseMode(
																	documentSettings!,
																	MouseMode.POINT,
																	MouseFunction.ATTACHMENT
																);

																documentManager.updateGlobalDocumentList();
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"attachment.area", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="attachment.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.SIGNATURE &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.signature"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || SignatureDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-signature"
														className={"menu-bar-signature-signature"}
														disabled={
															this.props.documentChecks &&
															!SignatureDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let signatureParameter: Parameter<PortalSignature> =
																	DialogDefault.getParameter(
																		PortalDialogType.SIGNATURE, selection
																	);
																let addParameter: PortalAddSignature =
																	signatureParameter.data.add as PortalAddSignature;
																addParameter.fieldName = "";
																addParameter.visible = false;
																signatureParameter.data.add = addParameter;

																this.props.context.getPage().setState({
																	signatureParameter: signatureParameter,
																	showSignatureDialog: true
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"signature.add", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || SignatureDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															(
																!SignatureDialogDefinition.isActive(
																	selection, portalInfo, this.props.signatureEditProfile
																) ||
																this.props.contentMode !== ContentMode.VIEWER
															)
														}
														icon="icon icon-signature-area"
														className={
															documentSettings?.activeViewer.mouseFunction === MouseFunction.SIGNATURE &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																this.setMouseMode(
																	documentSettings!,
																	MouseMode.RECTANGLE,
																	MouseFunction.SIGNATURE
																);

																documentManager.updateGlobalDocumentList();
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"signature.area", {ns: "menu"}
														)}/>
										}
										{
											(
												!this.props.documentChecks ||
												(
													SignatureRemoveDialogDefinition.isEnabled(portalInfo) &&
													SignatureRemoveDialogDefinition.checkRestrictions(
														selection, this.props.signatureEditProfile
													)
												)
											) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															!SignatureRemoveDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-delete small"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let signatureRemoveParameter: Parameter<Signature> =
																	DialogDefault.getParameter(
																		PortalDialogType.SIGNATURE_REMOVE, selection
																	);

																this.props.context.getPage().setState({
																	signatureRemoveParameter: signatureRemoveParameter,
																	showSignatureRemoveDialog: true
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"signature.remove", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="signature.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.EXPORT &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.export"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || ContentExtractionDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-export-content"
														disabled={
															this.props.documentChecks &&
															!ContentExtractionDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-export-content"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showContentExtractionDialog: true
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"export.content", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || ImageExtractionDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-export-images"
														disabled={
															this.props.documentChecks &&
															!ImageExtractionDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-export-images"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showImageExtractionDialog: true,
																	imageExtractionParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"export.image", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || InfoExtractionDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-export-info"
														disabled={
															this.props.documentChecks &&
															!InfoExtractionDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-export-info"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showInfoExtractionDialog: true,
																	infoExtractionParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"export.info", {ns: "menu"}
														)}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || PageExtractionDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-export-page"
														className="menu-bar-export-page"
														disabled={
															this.props.documentChecks &&
															!PageExtractionDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showPageExtractionDialog: true,
																	pageExtractionParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"export.page", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || HtmlExtractionDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-export-html"
														className="menu-bar-export-html"
														disabled={
															this.props.documentChecks &&
															!HtmlExtractionDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showHtmlExtractionDialog: true,
																	htmlExtractionParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"export.html", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="export.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.FORM &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.forms"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || FormsImportDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-forms-import"
														className="menu-bar-form-import"
														disabled={
															this.props.documentChecks &&
															!FormsImportDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showFormImportDialog: true,
																	formImportParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"form.add", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || FormsExtractionDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-forms-export"
														className="menu-bar-form-export"
														disabled={
															this.props.documentChecks &&
															!FormsExtractionDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showFormExtractionDialog: true,
																	formExtractionParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"form.export", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || FormsEditToolbarFunctionDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} icon="icon icon-forms-edit"
														disabled={
															this.props.documentChecks &&
															(
																!FormsEditToolbarFunctionDefinition.isActive(
																	selection, portalInfo, this.props.signatureEditProfile
																) ||
																this.props.contentMode !== ContentMode.VIEWER
															)
														}
														className={
															documentSettings?.activeViewer.mouseFunction === MouseFunction.FORMS_EDIT &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														onClick={async () => {
															if (documentSettings?.activeViewer.mouseMode === MouseMode.FORM) {
																return;
															}

															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																let immutable: PortalDocumentInterface =
																	this.props.documentSelection.get().pop()!;
																let selected: PortalDocument =
																	this.props.context.documentManager.findDocument(
																		immutable.id!
																	);

																this.setMouseMode(
																	documentSettings!, MouseMode.FORM,
																	MouseFunction.FORMS_EDIT
																);

																let formValues: FormValues = FormValues.fromMetadata(
																	selected.metadata?.form, documentSettings?.formInfo
																);

																let formsEditParameter: Parameter<ToolboxFormsForms> =
																	DialogDefault.getParameter(
																		PortalDialogType.EDIT_FORMS, [selected]
																	);

																this.props.context.getPage().setState({
																	showFormsEditFunction: true,
																	formsEditFunctionParameter: formsEditParameter,
																	formValues: Immutable.from(formValues.toJson())
																}, () => {
																	documentSettings!.activeViewer.mouseFunctionActive = true;
																	documentManager.updateGlobalDocumentList();
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value("form.edit", {ns: "menu"})}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || FormsFlattenDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-form-flatten"
														disabled={
															this.props.documentChecks &&
															!FormsFlattenDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-forms-flatten"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showDeleteFormsDialog: true,
																	deleteFormsParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"form.flatten", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="form.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.COMMENT &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.comment"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || AnnotationFlattenDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-comment-flatten"
														label={
															Translate.value("comment.flatten", {ns: "menu"})
														}
														disabled={
															this.props.documentChecks &&
															!AnnotationFlattenDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-flatten"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showAnnotationFlattenDialog: true,
																	annotationFlattenParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}/>
										}
										{(!this.props.documentChecks || AnnotationNoteFunctionDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														label={
															Translate.value("comment.note", {ns: "menu"})
														}
														disabled={
															this.props.documentChecks &&
															(
																!AnnotationNoteFunctionDefinition.isActive(
																	selection, portalInfo, this.props.signatureEditProfile
																) ||
																this.props.contentMode !== ContentMode.VIEWER
															)
														}
														icon="icon icon-annotation-note"
														className={
															documentSettings?.activeViewer.mouseFunction === MouseFunction.NOTE &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																this.setMouseMode(
																	documentSettings!,
																	MouseMode.RECTANGLE,
																	MouseFunction.NOTE
																);

																documentManager.updateGlobalDocumentList();

																let annotationNoteParameter: Parameter<ToolboxAnnotationAnnotation> =
																	this.props.annotationNoteParameter ||
																	DialogDefault.getParameter(PortalDialogType.ANNOTATION_NOTE, selection);
																this.props.context.getPage().setState({
																	mouseFunctionAnnotationParameter: Immutable.from(annotationNoteParameter.data.toJson())
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}/>
										}
										{
											(
												!this.props.documentChecks ||
												AnnotationMarkFunctionDefinition.isEnabled(portalInfo) ||
												AnnotationUnderlineFunctionDefinition.isEnabled(portalInfo) ||
												AnnotationStrikeFunctionDefinition.isEnabled(portalInfo) ||
												AnnotationSquigglyFunctionDefinition.isEnabled(portalInfo)
											) &&
											<MenuButton {...this.props} icon="icon icon-annotation-text"
														className={
															(
																documentSettings?.activeViewer.mouseFunction === MouseFunction.MARK ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.UNDERLINE ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STRIKE ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.SQUIGGLY
															) &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														tooltipOptions={{position: 'left'}}
														label={Translate.value("comment.text.label", {ns: "menu"})}
														menuItems={
															[
																{
																	className:
																		documentSettings?.activeViewer.mouseFunction === MouseFunction.MARK &&
																		this.props.contentMode === ContentMode.VIEWER ? "active" : "",
																	label: Translate.value(
																		"comment.text.mark", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationMarkFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	icon: "icon icon-annotation-mark",
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.SELECT,
																				MouseFunction.MARK
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationMarkParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationMarkParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_MARK, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationMarkParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className:
																		documentSettings?.activeViewer.mouseFunction === MouseFunction.UNDERLINE &&
																		this.props.contentMode === ContentMode.VIEWER ? "active" : "",
																	label: Translate.value(
																		"comment.text.underline", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationUnderlineFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	icon: "icon icon-annotation-underline",
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.SELECT,
																				MouseFunction.UNDERLINE
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationUnderlineParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationUnderlineParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_UNDERLINE, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationUnderlineParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className:
																		documentSettings?.activeViewer.mouseFunction === MouseFunction.STRIKE &&
																		this.props.contentMode === ContentMode.VIEWER ? "active" : "",
																	label: Translate.value(
																		"comment.text.strike", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStrikeFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	icon: "icon icon-annotation-strike",
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.SELECT,
																				MouseFunction.STRIKE
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStrikeParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStrikeParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STRIKE, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStrikeParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className:
																		documentSettings?.activeViewer.mouseFunction === MouseFunction.SQUIGGLY &&
																		this.props.contentMode === ContentMode.VIEWER ? "active" : "",
																	label: Translate.value(
																		"comment.text.squiggly", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationSquigglyFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	icon: "icon icon-annotation-squiggly",
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.SELECT,
																				MouseFunction.SQUIGGLY
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationSquigglyParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationSquigglyParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_SQUIGGLY, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationSquigglyParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																}
															]
														}/>
										}
									</div>
									<div className="menu-group">
										{
											(
												!this.props.documentChecks ||
												AnnotationLineFunctionDefinition.isEnabled(portalInfo) ||
												AnnotationSquigglyFunctionDefinition.isEnabled(portalInfo) ||
												AnnotationCircleFunctionDefinition.isEnabled(portalInfo)
											) &&
											<MenuButton {...this.props} icon="icon icon-shapes"
														className={
															(
																documentSettings?.activeViewer.mouseFunction === MouseFunction.LINE ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.SQUARE ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.CIRCLE
															) &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														tooltipOptions={{position: 'left'}}
														label={Translate.value("comment.shapes.label", {ns: "menu"})}
														menuItems={
															[
																{
																	className:
																		documentSettings?.activeViewer.mouseFunction === MouseFunction.LINE &&
																		this.props.contentMode === ContentMode.VIEWER ? "active" : "",
																	label: Translate.value(
																		"comment.shapes.line", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationMarkFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	icon: "icon icon-annotation-line area",
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.POINT,
																				MouseFunction.LINE
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationLineParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationLineParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_LINE, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationLineParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className:
																		documentSettings?.activeViewer.mouseFunction === MouseFunction.SQUARE &&
																		this.props.contentMode === ContentMode.VIEWER ? "active" : "",
																	label: Translate.value(
																		"comment.shapes.square", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationMarkFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	icon: "icon icon-annotation-square area",
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.SQUARE
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationSquareParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationSquareParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_SQUARE, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationSquareParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className:
																		documentSettings?.activeViewer.mouseFunction === MouseFunction.CIRCLE &&
																		this.props.contentMode === ContentMode.VIEWER ? "active" : "",
																	label: Translate.value(
																		"comment.shapes.circle", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationMarkFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	icon: "icon icon-annotation-circle area",
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.CIRCLE
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationCircleParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationCircleParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_CIRCLE, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationCircleParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																}
															]
														}/>
										}
										{
											(
												!this.props.documentChecks ||
												AnnotationStampFunctionDefinition.isEnabled(portalInfo)
											) &&
											<MenuButton {...this.props} icon="icon icon-annotation-stamp"
														menuClassName={"stamp-menu"}
														className={
															(
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_APPROVED ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_EXPERIMENTAL ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_NOT_APPROVED ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_AS_IS ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_EXPIRED ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_NOT_FOR_PUBLIC_RELEASE ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_CONFIDENTIAL ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_FINAL ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_SOLD ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_DEPARTMENTAL ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_FOR_COMMENT ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_TOP_SECRET ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_DRAFT ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_FOR_PUBLIC_RELEASE ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_CUSTOM
															) &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														tooltipOptions={{position: 'left'}}
														label={Translate.value("comment.stamp.label", {ns: "menu"})}
														menuItems={
															[
																{
																	className: "stamp-menuitem green" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_APPROVED &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.approved", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_APPROVED
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem green" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_FINAL &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.final", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_FINAL
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem blue" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_EXPERIMENTAL &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.experimental", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_EXPERIMENTAL
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem blue" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_SOLD &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.sold", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_SOLD
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem blue" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_DEPARTMENTAL &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.departmental", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_DEPARTMENTAL
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem blue" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_FOR_COMMENT &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.for_comment", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_FOR_COMMENT
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem blue" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_DRAFT &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.draft", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_DRAFT
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem blue" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_FOR_PUBLIC_RELEASE &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.for_public_release", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_FOR_PUBLIC_RELEASE
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem blue" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_NOT_FOR_PUBLIC_RELEASE &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.not_for_public_release", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_NOT_FOR_PUBLIC_RELEASE
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem red" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_NOT_APPROVED &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.not_approved", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_NOT_APPROVED
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem red" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_AS_IS &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.as_is", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_AS_IS
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem red" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_EXPIRED &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.expired", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_EXPIRED
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem red" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_CONFIDENTIAL &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.confidential", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_CONFIDENTIAL
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem red" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_TOP_SECRET &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.top_secret", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_TOP_SECRET
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<ToolboxAnnotationAnnotation> =
																				this.props.annotationStampParameter ||
																				DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection);
																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																},
																{
																	className: "stamp-menuitem" +
																		(documentSettings?.activeViewer.mouseFunction === MouseFunction.STAMP_CUSTOM &&
																		this.props.contentMode === ContentMode.VIEWER ? " active" : ""),
																	label: Translate.value(
																		"comment.stamp.custom", {ns: "menu"}
																	),
																	disabled: (
																		this.props.documentChecks &&
																		(
																			!AnnotationStampFunctionDefinition.isActive(
																				selection, portalInfo, this.props.signatureEditProfile
																			) ||
																			this.props.contentMode !== ContentMode.VIEWER
																		)
																	),
																	command: async () => {
																		let command: () => Promise<void> = async () => {
																			let documentSettings: DocumentSettings | undefined =
																				this.getCurrentSettings();
																			if (!FunctionHelper.exists(documentSettings)) {
																				return;
																			}

																			this.setMouseMode(
																				documentSettings!,
																				MouseMode.RECTANGLE,
																				MouseFunction.STAMP_CUSTOM
																			);

																			documentManager.updateGlobalDocumentList();

																			let annotationStampParameter: Parameter<PortalToolboxAnnotationAnnotation> =
																				FunctionHelper.applyValue(
																					this.props.annotationStampParameter,
																					DialogDefault.getParameter(PortalDialogType.ANNOTATION_STAMP, selection)
																				);

																			let content: string | undefined = annotationStampParameter.data.add!.rubberstamp![0].text;
																			if (content === "") {
																				content = Translate.value(
																					"annotation.appearance.stamp.default", {ns: "dialog"}
																				);
																			}
																			annotationStampParameter.data.add!.rubberstamp![0].text = content;

																			this.props.context.getPage().setState({
																				mouseFunctionAnnotationParameter: Immutable.from(annotationStampParameter.data.toJson())
																			});
																		}

																		if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																			DocumentSettings.confirmResetMouseFunction(this.props, command);
																			return;
																		}

																		await command();
																	}
																}
															]
														}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="comment.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.BARCODE &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.barcode"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || BarcodeCreateDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton
												{...this.props} icon="icon icon-barcode-create"
												className="menu-bar-barcode-create"
												disabled={
													this.props.documentChecks &&
													!BarcodeCreateDialogDefinition.isActive(
														selection, portalInfo, this.props.signatureEditProfile
													)
												}
												onClick={async () => {
													let command: () => Promise<void> = async () => {
														this.props.context.getPage().setState({
															showBarcodeCreateDialog: true,
															barcodeCreateParameter: undefined
														});
													}

													if (DocumentSettings.checkActiveMouseFunction(this.props)) {
														DocumentSettings.confirmResetMouseFunction(this.props, command);
														return;
													}

													await command();
												}}
												label={Translate.value("barcode.generate", {ns: "menu"})}/>
										}
										{(!this.props.documentChecks || BarcodeCreateAreaDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton
												{...this.props} icon="icon icon-barcode-create area"
												disabled={
													this.props.documentChecks &&
													(
														!BarcodeCreateAreaDialogDefinition.isActive(
															selection, portalInfo, this.props.signatureEditProfile
														) ||
														this.props.contentMode !== ContentMode.VIEWER
													)
												}
												className={
													documentSettings?.activeViewer.mouseFunction === MouseFunction.BARCODE_CREATE &&
													this.props.contentMode === ContentMode.VIEWER ? "active" : ""
												}
												onClick={async () => {
													let command: () => Promise<void> = async () => {
														let documentSettings: DocumentSettings | undefined =
															this.getCurrentSettings();
														if (!FunctionHelper.exists(documentSettings)) {
															return;
														}

														this.setMouseMode(
															documentSettings!,
															MouseMode.RECTANGLE,
															MouseFunction.BARCODE_CREATE
														);

														documentManager.updateGlobalDocumentList();
													}

													if (DocumentSettings.checkActiveMouseFunction(this.props)) {
														DocumentSettings.confirmResetMouseFunction(this.props, command);
														return;
													}

													await command();
												}}
												label={Translate.value("barcode.create", {ns: "menu"})}/>
										}
										{(!this.props.documentChecks || BarcodeCreateSwissQrCodeDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} splitButton={true}
														label={Translate.value(
															"barcode.swiss.title", {ns: "menu"}
														)}
														className={[
															"menu-bar-barcode-create-swiss-qr",
															(
																documentSettings?.activeViewer.mouseFunction === MouseFunction.BARCODE_CREATE_SWISS_CODE ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.BARCODE_CREATE_SWISS_BILL ||
																documentSettings?.activeViewer.mouseFunction === MouseFunction.BARCODE_CREATE_SWISS_BILL_WITH_SPACE
															) && this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														].join(" ")}
														disabled={
															this.props.documentChecks &&
															!BarcodeCreateSwissQrCodeDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-barcode-swiss"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showBarcodeSwissDialog: true,
																	barcodeSwissParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														menuItems={[
															{
																label: Translate.value(
																	"barcode.swiss.codeonly", {ns: "menu"}
																),
																command: async () => {
																	let command: () => Promise<void> = async () => {
																		let documentSettings: DocumentSettings | undefined =
																			this.getCurrentSettings();
																		if (!FunctionHelper.exists(documentSettings)) {
																			return;
																		}

																		this.setMouseMode(
																			documentSettings!,
																			MouseMode.RECTANGLE,
																			MouseFunction.BARCODE_CREATE_SWISS_CODE
																		);

																		documentManager.updateGlobalDocumentList();
																	}

																	if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																		DocumentSettings.confirmResetMouseFunction(this.props, command);
																		return;
																	}

																	await command();
																},
																disabled: (
																	this.props.documentChecks &&
																	(
																		!BarcodeCreateSwissQrCodeAreaDialogDefinition.isActive(
																			selection, portalInfo, this.props.signatureEditProfile
																		) ||
																		this.props.contentMode !== ContentMode.VIEWER
																	)
																),
																className: (
																	documentSettings?.activeViewer.mouseFunction ===
																	MouseFunction.BARCODE_CREATE_SWISS_CODE &&
																	this.props.contentMode === ContentMode.VIEWER ? "active" : ""
																)
															},
															{
																label: Translate.value(
																	"barcode.swiss.billonly", {ns: "menu"}
																),
																command: async () => {
																	let command: () => Promise<void> = async () => {
																		let documentSettings: DocumentSettings | undefined =
																			this.getCurrentSettings();
																		if (!FunctionHelper.exists(documentSettings)) {
																			return;
																		}

																		this.setMouseMode(
																			documentSettings!,
																			MouseMode.RECTANGLE,
																			MouseFunction.BARCODE_CREATE_SWISS_BILL
																		);

																		documentManager.updateGlobalDocumentList();
																	}

																	if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																		DocumentSettings.confirmResetMouseFunction(this.props, command);
																		return;
																	}

																	await command();
																},
																disabled: (
																	this.props.documentChecks &&
																	(
																		!BarcodeCreateSwissQrCodeAreaDialogDefinition.isActive(
																			selection, portalInfo, this.props.signatureEditProfile
																		) ||
																		this.props.contentMode !== ContentMode.VIEWER
																	)
																),
																className: (
																	documentSettings?.activeViewer.mouseFunction ===
																	MouseFunction.BARCODE_CREATE_SWISS_BILL &&
																	this.props.contentMode === ContentMode.VIEWER ? "active" : ""
																)
															},
															{
																label: Translate.value(
																	"barcode.swiss.billextraspace", {ns: "menu"}
																),
																command: async () => {
																	let command: () => Promise<void> = async () => {
																		let documentSettings: DocumentSettings | undefined =
																			this.getCurrentSettings();
																		if (!FunctionHelper.exists(documentSettings)) {
																			return;
																		}

																		this.setMouseMode(
																			documentSettings!,
																			MouseMode.RECTANGLE,
																			MouseFunction.BARCODE_CREATE_SWISS_BILL_WITH_SPACE
																		);

																		documentManager.updateGlobalDocumentList();
																	}

																	if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																		DocumentSettings.confirmResetMouseFunction(this.props, command);
																		return;
																	}

																	await command();
																},
																disabled: (
																	this.props.documentChecks &&
																	(
																		!BarcodeCreateSwissQrCodeAreaDialogDefinition.isActive(
																			selection, portalInfo, this.props.signatureEditProfile
																		) ||
																		this.props.contentMode !== ContentMode.VIEWER
																	)
																),
																className: (
																	documentSettings?.activeViewer.mouseFunction ===
																	MouseFunction.BARCODE_CREATE_SWISS_BILL_WITH_SPACE &&
																	this.props.contentMode === ContentMode.VIEWER ? "active" : ""
																)
															}
														]}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || BarcodeDetectDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton
												{...this.props}
												disabled={
													this.props.documentChecks &&
													(
														!BarcodeDetectDialogDefinition.isActive(
															selection, portalInfo, this.props.signatureEditProfile
														) ||
														this.props.contentMode !== ContentMode.VIEWER
													)
												}
												icon="icon icon-barcode-detect area"
												className={
													documentSettings?.activeViewer.mouseFunction === MouseFunction.BARCODE_DETECT &&
													this.props.contentMode === ContentMode.VIEWER ? "active" : ""
												}
												onClick={async () => {
													let command: () => Promise<void> = async () => {
														let documentSettings: DocumentSettings | undefined =
															this.getCurrentSettings();
														if (!FunctionHelper.exists(documentSettings)) {
															return;
														}

														this.setMouseMode(
															documentSettings!,
															MouseMode.RECTANGLE,
															MouseFunction.BARCODE_DETECT
														);

														documentManager.updateGlobalDocumentList();
													}

													if (DocumentSettings.checkActiveMouseFunction(this.props)) {
														DocumentSettings.confirmResetMouseFunction(this.props, command);
														return;
													}

													await command();
												}}
												label={Translate.value("barcode.detect", {ns: "menu"})}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="barcode.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.state.activeTab === MenuTabs.REDACT &&
							<div className="tab-panel">
								{this.renderDocumentSettings()}
								<div className="menu-block" ref={this.resizeContainer} data-help="global.menu.redact"
									 data-position="bottom">
									<div className="menu-group">
										{(!this.props.documentChecks || RedactDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className="menu-bar-redact-apply"
														disabled={
															this.props.documentChecks &&
															!RedactDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-redact-apply"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showRedactDialog: true,
																	redactParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"redact.apply", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || RedactTextFunctionDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															(
																!RedactTextFunctionDefinition.isActive(
																	selection, portalInfo, this.props.signatureEditProfile
																) ||
																this.props.contentMode !== ContentMode.VIEWER
															)
														}
														icon="icon icon-redact-text"
														className={
															documentSettings?.activeViewer.mouseFunction === MouseFunction.REDACT_TEXT &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																this.setMouseMode(
																	documentSettings!,
																	MouseMode.SELECT,
																	MouseFunction.REDACT_TEXT
																);

																documentManager.updateGlobalDocumentList();

																let redactTextParameter: Parameter<PortalToolboxAnnotationAnnotation> =
																	this.props.redactTextParameter ||
																	DialogDefault.getParameter(PortalDialogType.REDACT_TEXT, selection);
																this.props.context.getPage().setState({
																	mouseFunctionAnnotationParameter: Immutable.from(redactTextParameter.data.toJson())
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"redact.text", {ns: "menu"}
														)}/>
										}
										{(!this.props.documentChecks || RedactAreaFunctionDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props}
														disabled={
															this.props.documentChecks &&
															(
																!RedactAreaFunctionDefinition.isActive(
																	selection, portalInfo, this.props.signatureEditProfile
																) ||
																this.props.contentMode !== ContentMode.VIEWER
															)
														}
														icon="icon icon-redact-area"
														className={
															documentSettings?.activeViewer.mouseFunction === MouseFunction.REDACT_AREA &&
															this.props.contentMode === ContentMode.VIEWER ? "active" : ""
														}
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																let documentSettings: DocumentSettings | undefined =
																	this.getCurrentSettings();
																if (!FunctionHelper.exists(documentSettings)) {
																	return;
																}

																this.setMouseMode(
																	documentSettings!,
																	MouseMode.RECTANGLE,
																	MouseFunction.REDACT_AREA
																);

																documentManager.updateGlobalDocumentList();

																let redactAreaParameter: Parameter<PortalToolboxAnnotationAnnotation> =
																	this.props.redactAreaParameter ||
																	DialogDefault.getParameter(PortalDialogType.REDACT_AREA, selection);
																this.props.context.getPage().setState({
																	mouseFunctionAnnotationParameter: Immutable.from(redactAreaParameter.data.toJson())
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"redact.area", {ns: "menu"}
														)}/>
										}
									</div>
									<div className="menu-group">
										{(!this.props.documentChecks || RedactPageDialogDefinition.isEnabled(portalInfo)) &&
											<MenuButton {...this.props} className={"menu-bar-redact-page"}
														disabled={
															this.props.documentChecks &&
															!RedactPageDialogDefinition.isActive(
																selection, portalInfo, this.props.signatureEditProfile
															)
														}
														icon="icon icon-redact-page"
														onClick={async () => {
															let command: () => Promise<void> = async () => {
																this.props.context.getPage().setState({
																	showRedactPageDialog: true,
																	redactPageParameter: undefined
																});
															}

															if (DocumentSettings.checkActiveMouseFunction(this.props)) {
																DocumentSettings.confirmResetMouseFunction(this.props, command);
																return;
															}

															await command();
														}}
														label={Translate.value(
															"redact.page", {ns: "menu"}
														)}/>
										}
									</div>
									<p className="menu-group-label">
										<Translate {...this.props} data="redact.title" namespace="menu"/>
									</p>
								</div>
							</div>
						}
						{this.renderLabel()}
					</div>
				</div>
			</>
		);
	}
}

const PortalMenuBar = React.memo(PortalMenuBarDefinition,
	(prevProps: Readonly<PortalMenuBarProperties>, nextProps: Readonly<PortalMenuBarProperties>) => {
		if (!nextProps.portalDocuments.equals(prevProps.portalDocuments)) {
			return false;
		}

		if (!nextProps.documentSelection.equals(prevProps.documentSelection)) {
			return false;
		}

		if (nextProps.mouseFunctionRect !== null && !nextProps.mouseFunctionRect.equals(prevProps.mouseFunctionRect)) {
			return false;
		}

		if (nextProps.mouseFunctionPoint !== null && !nextProps.mouseFunctionPoint.equals(prevProps.mouseFunctionPoint)) {
			return false;
		}

		if (nextProps.mouseFunctionLine !== null && !nextProps.mouseFunctionLine.equals(prevProps.mouseFunctionLine)) {
			return false;
		}

		if (nextProps.textSelection !== null && !nextProps.textSelection.equals(prevProps.textSelection)) {
			return false;
		}

		if (nextProps.userCertificates !== null && !nextProps.userCertificates.equals(prevProps.userCertificates)) {
			return false;
		}

		if (nextProps.userSettings !== null && !nextProps.userSettings.equals(prevProps.userSettings)) {
			return false;
		}

		if (nextProps.contentMode !== prevProps.contentMode) {
			return false;
		}

		if (nextProps.language !== prevProps.language) {
			return false;
		}

		if (nextProps.showLog !== prevProps.showLog) {
			return false;
		}

		if (nextProps.userId !== prevProps.userId) {
			return false;
		}

		if (nextProps.signatureEditProfile !== prevProps.signatureEditProfile) {
			return false;
		}

		if (nextProps.showAnnotationLineFunction !== prevProps.showAnnotationLineFunction) {
			return false;
		}

		if (nextProps.showAnnotationCircleFunction !== prevProps.showAnnotationCircleFunction) {
			return false;
		}

		if (nextProps.showAnnotationSquareFunction !== prevProps.showAnnotationSquareFunction) {
			return false;
		}

		if (nextProps.showAnnotationMarkFunction !== prevProps.showAnnotationMarkFunction) {
			return false;
		}

		if (nextProps.showAnnotationUnderlineFunction !== prevProps.showAnnotationUnderlineFunction) {
			return false;
		}

		if (nextProps.showAnnotationSquigglyFunction !== prevProps.showAnnotationSquigglyFunction) {
			return false;
		}

		if (nextProps.showAnnotationStrikeFunction !== prevProps.showAnnotationStrikeFunction) {
			return false;
		}

		if (nextProps.showAnnotationNoteFunction !== prevProps.showAnnotationNoteFunction) {
			return false;
		}

		if (nextProps.showRedactAreaFunction !== prevProps.showRedactAreaFunction) {
			return false;
		}

		if (nextProps.showRedactTextFunction !== prevProps.showRedactTextFunction) {
			return false;
		}

		if (nextProps.showAnnotationReplyFunction !== prevProps.showAnnotationReplyFunction) {
			return false;
		}

		if (nextProps.showAnnotationStampFunction !== prevProps.showAnnotationStampFunction) {
			return false;
		}

		return true;
	}
);

export default PortalMenuBar;